import {
  DocumentType,
  LenderName,
  PaymentMode,
  PaymentPlanLineStatus,
} from "@nemuru-eng/js-api-client";
import esLocale from "date-fns/locale/es";
import React from "react";
import { ACTION_EXCEPTIONS } from "../../../utils/getActionException";
import { DefaultTermsAndConditionEs } from "../termsAndConditions/es/defaultTermsAndConditionsEs";
import { INSURANCE_PACK } from "../../../components/modules/card/Card/config";

const es = {
  SIGNING_IN: "Iniciando...",
  AUTH_ERROR: "Error de autentificación",
  WELCOME_BACK: "Hola de nuevo",
  RESUME_LOAN_PROCESS: "Continúa tu proceso donde lo dejaste.",
  CONTINUE: "Continuar",

  // Sections
  SECTION_IDENTIFICATION: "Identidad",
  DOCUMENT_ID_VERIFICATION: "Verificación $v1",
  VERIFYING_DOCUMENT: "Verificando documento…",
  UPLOADING_DOCUMENT_PICTURE: "Subiendo imágen…",
  UPLOADING_FRONT_PICTURE: "Subiendo imagen delantera…",
  UPLOADING_BACK_PICTURE: "Subiendo imagen trasera…",
  LOADING_VERIFICATION_STATUS: "Cargando el estado de la verificación…",
  DOCUMENT_TYPE_SELECTION_INSTRUCTIONS:
    "Verificaremos tu identidad de forma rápida y segura. Solo te llevará un par de minutos.",
  TRUSTED_ID_VERIFICATION: "Tus datos están protegidos conforme al RGPD",
  START_VERIFICATION: "Empezar verificación",
  SELECT_YOUR_DOCUMENT_TYPE: "Selecciona tu tipo de documento",
  INSTRUCTIONS_FOR_DOCUMENT_VERIFICATION: "Instrucciones",
  ACTION_REQUEST_GET_ID_DOCUMENT_VERIFICATION_STATUS_REJECTED: (
    <div>
      <p>
        En estos momentos no hemos podido recuperar el estado de la verificación
        de tu documento de identidad.
      </p>
      <br></br>
      <span>Por favor: </span>
      <p>
        <ul>
          <li>Vuelve a intentarlo clicando en el botón abajo.</li>
          <li>Si el error persiste, vuelve a intentarlo más tarde.</li>
        </ul>
      </p>
    </div>
  ),
  VERIFICATION_FAILED: "La verificación ha fallado",
  ID_DOC_VERIFICATION_FAILED_TITLE:
    "Lo sentimos, no hemos podido verificar tu documento.",
  ID_DOC_VERIFICATION_ATTEMPTS: "Intentos: $v1/$v2",
  RESTART_PROCESS: "Reiniciar proceso",
  ID_DOC_VERIFICATION_LIMITED_ATTEMPTS_TITLE: "Intentos limitados",
  ID_DOC_VERIFICATION_LIMITED_ATTEMPTS_BODY:
    "Tienes un número limitado de intentos ($v1 de $v2).",
  ID_DOC_VERIFICATION_REASON_TIMEOUT:
    "La sesión de subida ha caducado. Por favor, ten el documento preparado y completa el proceso de fotos más rápido en el siguiente intento.",
  ID_DOC_VERIFICATION_REASON_RECOGNITION:
    "No se ha podido reconocer el documento, puede estar dañado, puede no haberse subido con la orientación correcta o no corresponder al número de documento de identidad que se ha utilizado para iniciar esta solicitud. Utiliza el documento original, asegúrate de que está bien encuadrado, es legible y no tiene reflejos, y mantenlo en posición horizontal.",
  ID_DOC_VERIFICATION_MAX_ATTEMPTS:
    "Has agotado todos tus intentos de verificación de identidad. Por favor, vuelve a generar el pedido e inténtalo de nuevo.",
  ID_DOC_UPLOAD_PROCESS_EXPIRED_TITLE: "Sesión caducada",
  ID_DOC_UPLOAD_PROCESS_EXPIRED_BODY:
    "La sesión de subida ha caducado. Reinicia el proceso para continuar.",
  ID_DOC_UPLOAD_INVALID_PHOTO_TITLE: "Foto $v1 no válida",
  ID_DOC_UPLOAD_INVALID_PHOTO_BODY:
    "No hemos podido validar esta imagen. Vuelve a hacer la foto y asegúrate de que el documento está claro y bien encuadrado.",
  ID_DOC_UPLOAD_TRANSACTIONAL_ERROR_TITLE: "No hemos podido subir la foto",
  ID_DOC_UPLOAD_TRANSACTIONAL_ERROR_BODY:
    "Inténtalo de nuevo en unos segundos. Si el problema persiste, reinicia el proceso.",
  ID_DOC_UPLOAD_GENERIC_ERROR_TITLE: "Algo ha salido mal",
  ID_DOC_UPLOAD_GENERIC_ERROR_BODY:
    "No hemos podido subir la imágenes. Por favor, inténtalo de nuevo.",
  ID_DOC_UPLOAD_CAPTURED_GENERIC_ERROR_BODY:
    "No hemos podido subir la imágen capturada. Por favor, inténtalo de nuevo.",
  ID_DOC_VERIFY_GENERIC_ERROR_BODY:
    "No hemos podido validar tu documento. Por favor, inténtalo de nuevo.",
  ID_VERIFICATION_EXTRACTED_DATA_FORM_TITLE: "Verificación de identidad",
  ID_VERIFICATION_EXTRACTED_DATA_FORM_SUBTITLE:
    "Revisa y completa los datos de tu documento de identidad.",
  ID_VERIFICATION_EXTRACTED_DATA_LOADING: "Leyendo los datos de tu documento…",
  ID_VERIFICATION_EXTRACTED_DATA_LOAD_ERROR_TITLE:
    "No hemos podido leer tus datos",
  ID_VERIFICATION_EXTRACTED_DATA_LOAD_ERROR:
    "No hemos podido leer los datos de tu documento. Por favor, inténtalo de nuevo.",
  ISSUING_COUNTRY: "País emisor",
  PROCESS_INFO_BULLET_ORIGINAL:
    "Utiliza un documento original. No utilices una copia.",
  PROCESS_INFO_BULLET_FRAME:
    "Asegúrate de que el documento está encuadrado dentro del marco. Debe ser legible y estar enfocado.",
  PROCESS_INFO_BULLET_HORIZONTAL:
    "El documento debe estar en posición horizontal.",
  PROCESS_INFO_BULLET_NOT_UNDERAGED: "El titular debe ser mayor de edad.",
  PROCESS_INFO_BULLET_NOT_EXPIRED: "El documento no debe estar caducado.",
  PHOTO_WILL_BE_UPLOADED_FOR_VERIFICATION:
    "Esta será la foto que subiremos al sistema para verificación. Asegúrate de que el documento está encuadrado dentro del marco, es legible y está enfocado.",
  PROCESS_INFO_BULLET_GOOD_LIGHTING:
    "Busca buena iluminación y evita reflejos.",
  PHOTO_ID_DOCUMENT_front: (
    <>
      Toma la foto <strong>delantera</strong> de tu documento de identidad
    </>
  ),
  PHOTO_ID_DOCUMENT_back: (
    <>
      Toma la foto <strong>trasera</strong> de tu documento de identidad
    </>
  ),
  STEP_X_OF_Y: "Paso $v1 de $v2",
  SECTION_FINANCES: "Finanzas",
  SECTION_SUMMARY: "Solicitud",
  SECTION_DOCUMENTATION_AND_SIGNATURE: "Documentación y firma",
  SECTION_DOCUMENTATION: "Documentación",
  SECTION_SIGNATURE: "Firma",

  AUTOCOMPLETE: "Autocompletar",

  // NotFound
  SORRY: "Lo sentimos",
  PAGE_NOT_FOUND: "Página no encontrada",
  PROCESS_NOT_ALLOWED_FOR_THIS_LOAN:
    "Este proceso no está permitido para esta solicitud",
  THE_IDENTIFICATION_PARAMETERS_FOR_THIS_PROCESS_ARE_NOT_CORRECT:
    "Las credenciales requeridas para este proceso no son correctas",
  // Disabled
  OOPS: "¡Oooops!",
  LOAN_IS_DISABLED: "La solicitud ya no existe",

  // Critical Error Information
  OOPS_SOMETHING_WENT_WRONG: "¡Oooops! Algo ha fallado",
  PLEASE_RESET_THE_APP:
    "Prueba reiniciar la aplicación. Si el error persiste, ponte en contacto con nuestro servicio de atención al cliente.",
  COULD_NOT_FIND_YOUR_BANK_ACCOUNT_NUMBER:
    "No hemos sido capaces de encontrar tu número de cuenta. Por favor, ponte en contacto con nuestro servicio de atención al cliente en el teléfono $v1.",
  COULD_NOT_FIND_YOUR_BANK_ACCOUNT_NUMBER_CONTACT_CUSTOMER_SUPPORT_CHAT:
    "No hemos sido capaces de encontrar tu número de cuenta. Por favor, ponte en contacto con nuestro servicio de atención al cliente en el teléfono $v1 o vía chat.",
  // InfoPanel
  WHICH_DOCUMENTS: "¿Qué documentos debes tener a mano?",
  WELCOME_TO_ID_VERIFICATION_TITLE: "Verifiquemos tu identidad",
  WELCOME_TO_ID_VERIFICATION_BODY:
    "Verificaremos tu identidad con tu documento de identificación. Es un paso obligatorio para poder continuar con tu solicitud.",
  WELCOME_TO_ID_VERIFICATION_REASSURANCE:
    "Suele tardar 1–2 minutos y tus fotos se usan solo para la verificación.",
  DNI_OR_NIE: "DNI o NIE válido.",
  NIE_EU_PASSPORT:
    "En caso de tener NIE Europeo sin foto, además te pediremos el pasaporte.",
  WHAT_DATA_REQUESTED: "¿Qué otros datos te pediremos?",
  ENTRANCE_DATE: "Fecha de entrada a tu domicilio actual.",
  OWNERSHIP_CONTRACT:
    "Si el domicilio es de tu propiedad, si es contrato privado, escritura pública o vivienda social.",
  MORTAGE_EXPENSES: "Si tienes hipoteca, cuánto pagas de hipoteca al mes.",
  MARITAL_REGIME_TYPES:
    "Si estás casado/a, si el régimen es de separación de bienes o de gananciales.",
  IBAN: "Número de cuenta bancaria (IBAN) donde domiciliar el préstamo.",
  WHAT_IS_PUBLIC_DEED: "¿Qué es escritura pública?",
  PUBLIC_DEED_EXPLANATION:
    "Cuando el contrato de compraventa entre la parte compradora y vendedora, que recoge por escrito los datos de ambas partes y las condiciones de la operación (inmueble, forma de pago, etc.), se eleva ante notario y es éste el encargado de certificar la validez del contrato e inscribir la propiedad en el Registro de la Propiedad. Éste es el procedimiento más habitual.",
  WHAT_IS_PRIVATE_CONTRACT: "¿Qué es contrato privado?",
  PRIVATE_CONTRACT_EXPLANATION:
    "Cuando el contrato de compraventa entre la parte compradora y vendedora, que recoge por escrito los datos de ambas partes y las condiciones de la operación (inmueble, forma de pago, etc.), no se celebra ante un notario para darle la forma de escritura pública. El contrato privado no tiene acceso al Registro de la Propiedad.",
  WHAT_IS_SOCIAL_HOUSING: "¿Qué es vivienda social?",
  SOCIAL_HOUSING_EXPLANATION:
    "Cuando se adquiere un inmueble de la Agencia de la Vivienda Social.",
  WHAT_IS_MATRIMONIAL_ASSETS: "¿Qué es el régimen de gananciales?",
  MATRIMONIAL_ASSETS_EXPLANATION:
    "El régimen de gananciales pone en común los bienes y ganancias que se logran durante el matrimonio. En otras palabras, todo el patrimonio que se obtenga durante el matrimonio pasará a ser de ambos a partes iguales, sin importar si es fruto del trabajo o de las rentas de cualquier de ellos",
  WHAT_IS_SEPARATE_PROPERTY: "¿Qué es la separación de bienes?",
  SEPARATE_PROPERTY_EXPLANATION:
    "En el régimen de separación de bienes, tanto los bienes que cada una de las personas tiene antes de casarse como los que adquiera después, serán suyos y no de la otra persona.",
  HOW_IT_WORKS: "¿Cómo funciona?",
  HOW_IT_WORKS_INTRO:
    "Este proceso se realiza a través de Eurobits Technologies (empresa que cumple con los máximos estándares de seguridad certificada en ISO 27001, regulada y aprobada por Banco de España bajo normativa PSD2 y Decreto-Ley 19/2018). Sólo tienes que:",
  HOW_IT_WORKS_BANK: "Seleccionar tu banco.",
  HOW_IT_WORKS_LOGIN:
    "Hacer login como si se tratara de tu banca online. Recuerda que NO es el PIN de tu tarjeta.",
  HOW_IT_WORKS_IBAN:
    "Seleccionar la cuenta bancaria donde deseas domiciliar las cuotas del préstamo.",
  HOW_IT_WORKS_DONE: "¡Listo!",
  WHAT_DATA_IS_READ: "¿Qué datos se van a leer?",
  WHAT_DATA_IS_READ_IDENTIFICATION: "Datos identificativos (titulares e IBAN)",
  WHAT_DATA_IS_READ_STATEMENTS: "Historial de movimientos",
  WHAT_DATA_IS_READ_BALANCE: "Balance",
  WHICH_GOAL: "¿Para qué se van a usar los datos?",
  WHICH_GOAL_INCOME:
    "Usamos los datos de tu cuenta bancaria para estimar tu capacidad de pago y poder evaluar tu solicitud de forma rápida y segura. Además, validamos que eres el titular de la cuenta seleccionada.",
  WHICH_GOAL_IBAN:
    "Establecer la cuenta en la que deseas domiciliar las cuotas del préstamo.",
  DNI_ES_TITLE: "DNI Español",
  DNI_ES_EXPLANATION:
    "Documento Nacional de Identidad para ciudadanos/as con nacionalidad española",
  NIE_UE_TITLE: "NIE dentro Unión Europea (sin foto)",
  NIE_UE_EXPLANATION:
    "Número de Identidad Extranjero (NIE) de ciudadanos/as comunitarios/as (dentro de la Unión Europea). El documento no tiene fotografía.",
  NIE_NON_UE_TITLE: "NIE fuera Unión Europea (con foto)",
  NIE_NON_UE_EXPLANATION:
    "Corresponde a la Tarjeta de Identidad de Extranjero (TIE) de ciudadanos/as NO europeos/as. El documento contiene fotografía.",

  //Welcome Wizard
  LETS_GO: "Hola de nuevo",
  YOUR_LOAN_PROCESS: "Así está el proceso",
  IDENTIFICATION: "Identificación",
  ID_CHECK: "Comprobación de identidad",
  PROFESSIONAL_AND_FINANCIAL_DATA: "Datos financieros y profesionales",
  SUMMARY: "Resumen",
  LOAN_ADJUSTMENT_AND_EVALUATION: "Ajuste y evaluación final",
  PROPOSAL_DETAILS: "Propuesta enviada por $v1 por un importe de $v2€",
  PROPOSAL_DETAILS_WITHOUT_AMOUNT: "Propuesta enviada por $v1",
  DOCUMENTATION_AND_SIGNATURE: "Documentación y firma",
  SIGNATURE: "Firma",
  UPLOAD_DOCUMENTATION_AND_SIGN: "Subir documentación y firma digital",

  // Slider
  HI: "Hola",
  START: "Comenzar",
  SKIP: "Saltar",
  DESCRIPTION: "Descripción",

  // Step 1
  WELCOME: "Bienvenid@",
  WELCOME_TO_NEMURU: "Bienvenid@ a Nemuru",
  INVITATION_MSG:
    "$v1 te ha invitado a realizar el proceso para poder pagar a plazos",
  NEUTRAL_INVITATION_MSG:
    "Se te ha invitado a realizar el proceso para poder pagar a plazos",
  INVITATION_MSG_CARD:
    "$v1 te ha invitado a realizar el proceso de contratación de tu tarjeta de crédito",

  GET_YOUR_LOAN: "Desde aquí podrás solicitar tu préstamo.",
  // Step 2
  WHAT_IS_NEMURU: "¿Qué es Nemuru?",
  YOU_SHOULD_KNOW: "Debes saber que...",
  NEMURU_INTRO:
    "Nemuru es la plataforma tecnológica que te permite solicitar tu financiación en 3 simples pasos.",
  NEMURU_INTRO_SUB:
    "No somos una financiera, sino que trabajamos con las principales entidades financieras.",
  // Step 3
  WHAT_WILL_YOU_NEED: "¿Qué necesitarás?",
  DOCUMENT_RECOMMENDATION:
    "Antes de empezar, considera los siguientes puntos, por favor.",
  DNI_OR_NIE_DOC: "Documento DNI o NIE válido.",
  WE_WILL_REQUEST_INFORMATION: "te pediremos información",
  ABOUT_YOUR_FINANCES:
    "sobre finanzas y datos profesionales necesarios para procesar tu solicitud de préstamo",
  ALL_INFO_PRIVATE:
    "Toda la informacion será privada y protegida estrictamente",
  SPANISH_ACCOUNT: "Cuenta bancaria española.",
  INCOME: "Ingresos",
  SPANISH_ACCOUNT_DETAIL:
    "Debes tener una cuenta bancaria española donde domiciliar las cuotas del préstamo.",
  OTHER_DOCUMENTS: "Otros documentos",
  OTHER_DOCUMENTS_DETAIL:
    "Si aún no eres cliente CaixaBank, te pediremos que nos facilites un justificante de ingresos (como una nómina, declaración de la renta, etc.) y un justificante de titularidad de la cuenta bancaria que nos hayas dado para domiciliar tus cuotas.",
  // Step 5
  DNI_OR_NIE_VALID: "DNI, NIE o Pasaporte válido",
  DNI_NIE_OR_PASSPORT_DOC:
    "En caso de no tener DNI o NIE Europeo válido, te pediremos una foto del pasaporte.",
  EUROPEAN_BANK_ACCOUNT: "Cuenta bancaria europea",
  SEPA_PAYMENT_DETAILS:
    "Debes tener una cuenta bancaria dentro de la Zona Única de Pagos en Euros (SEPA) dónde domiciliar las cuotas del préstamo. En caso de no disponer de una cuenta bancaria europea, te vamos a ofrecer un método de pago alternativo a través de Flywire",
  SEPA_BANK_ACCOUNT_TITLE: "Zona Única de Pagos en Euros (SEPA)",
  SEPA_BANK_ACCOUNT_EXPLANATION:
    "El área SEPA está formado por treinta y seis países: los miembros del Espacio Económico Europeo (compuesto por los veintisiete estados de la Unión Europea más Liechtenstein, Islandia y Noruega) y Andorra, Mónaco, San Marino, Suiza, Reino Unido y Ciudad del Vaticano Estado",
  // GDPR
  TERMS_AND_CONDITIONS: DefaultTermsAndConditionEs,
  ACCEPT: "Aceptar",
  CANCEL: "Cancelar",
  PLEASE_ACCEPT_CONDITIONS: "Es necesario aceptar esta condición.",
  REQUIRED: "(Requerido)",
  PROVIDE_CONDITIONS_TO_CLIENT:
    "Por favor, facilite los términos y condiciones a su cliente.",
  UPF_GDPR_AND_PRIVACY_POLICY_OPTIN: (
    <p>
      Nemuru compartirá tus datos y el informe de solvencia con la Fundació
      Institut d’Educació Continua, la cual procesará los datos de acuerdo con
      los términos y condiciones establecidos en sus condiciones generales y su
      política de privacidad que previamente has aceptado y puedes encontrar en
      el siguiente{" "}
      <a
        href="https://www.bsm.upf.edu/documents/condiciones-generales-esp-20231106.pdf"
        target="_blank"
      >
        enlace
      </a>
      .
    </p>
  ),

  // FLOW MESSAGES
  END_SECTION_IDENTIFICATION: "Identidad confirmada",
  END_SECTION_FINANCES: "Datos financieros introducidos correctamente",
  CONGRATULATIONS: "¡Felicidades!",
  THANKS: "¡Gracias!",
  CONGRATULATIONS_SIGNATURE_NOT_AVAILABLE: "¡Felicidades!",
  CONGRATULATION_DOCUMENTS_UPLOADED: "¡Felicidades!",
  CONGRATULATIONS_APPROVED_END: "¡Felicidades!",
  WE_ARE_SORRY: "Lo sentimos",
  THANKS_LOAN_FORM_COMPLETED: "Has completado el proceso correctamente.",
  THANKS_LOAN_FORM_COMPLETED_AND_PREAPPROVED_DOCS_AND_SIGNATURE_REDIRECT:
    "¡Tu solicitud ha sido preaprobada y está pendiente de validación!",
  THANKS_LOAN_FORM_COMPLETED_AND_PREAPPROVED:
    "¡Tu solicitud ha sido preaprobada y está pendiente de validación!",
  APPLICATION_PENDING_APPROVAL: "¡Tu solicitud está pendiente de aprobación!",
  LENDER_SELECTED_PENDING_APPROVAL:
    "Tu solicitud está pendiente de aprobación por la entidad financiera seleccionada. Recibirás un correo electrónico para continuar con el proceso en caso de aprobación.",
  LOAN_PREAPPROVED_DOCUMENTATION_NEEDED:
    "La solicitud está sujeta a validación por la entidad financiera. ¡Sube ahora la documentación para obtener la confirmación final más rápidamente!",
  LOAN_HAS_BEEN_DENIED: "Tu solicitud no ha sido aprobada",
  YOUR_COMMERCIAL_AGENT_WILL_CONTACT_YOU_SOON_FOR_MORE_DETAILS: (
    <p>
      Hemos realizado el estudio de solicitud de financiación. Tu{" "}
      <strong>agente comercial</strong> te contactará en breve para informarte
      de los próximos pasos.
    </p>
  ),
  LOAN_ONBOARDINGS_ARE_NOT_COMPLETED:
    "$v1 tiene/n pendiente rellenar sus datos:",
  LOAN_ANALYSING:
    "Hemos lanzado tu solicitud a las entidades financieras y te contestaremos pronto. ¡Estáte atent@!",
  LOAN_ANALYSING_DOCUMENTATION_NEEDED:
    "Hemos lanzado tu solicitud a las entidades financieras. ¡Sube ahora la documentación para obtener la respuesta más rápidamente!",
  DOWN_PAYMENT_PENDING: "Pagar la entrada",
  INVALID_DOWN_PAYMENT_CHECKOUT_SESSION_FOR_SIGNATURE:
    "Tu entrada está pendiente de pago",
  YOU_MUST_PAY_THE_DOWN_PAYMENT_BEFORE_SIGNING_THE_CONTRACT:
    "Completa el pago de la entrada con el método de pago que más te convenga.",
  CLOSE_THE_DIALOG_AND_PAY_THE_DOWN_PAYMENT: (
    <>
      <>
        Debes realizar el pago de la entrada previamente a la firma del
        contrato.
      </>
      <p>
        Cierra esta ventana emergente y procede al pago de la entrada, eligiendo
        dicha opción en la pagina de métodos de pago.
      </p>
    </>
  ),

  THANKS_DOCUMENTATION_UPLOADED:
    "Has subido la documentación correctamente, muchas gracias.",
  APPROVED: "¡Tu solicitud ha sido preaprobada!",
  IN_CASE_OF_APPROVAL: "En caso de aprobación",
  WAITING_FOR_REMAINING_ACTIONS:
    "Un momento, estamos comprobando si queda alguna acción pendiente...",
  TWO_ACTIONS_REMAINING: "Completa los siguientes 2 pasos",
  THREE_ACTIONS_REMAINING: "Completa los siguientes 3 pasos",
  ONE_ACTION_REMAINING: "Completa el siguiente paso",
  NO_ACTION_REMAINING: "Todos los pasos completados",
  DOCS_COMPLETED: "Documentación subida",
  DOCS_PENDING: "Subir tu documentación",
  ONBOARDING_COMPLETED: "Datos correctamente rellenados",
  PENDING_ONBOARDING: "Pendiente rellenar datos",
  PENDING_ONBOARDING_INFO:
    "Una vez que todos los participantes de la solicitud hayan rellenado sus datos, podrás cargar la documentación y firmar el contrato de forma digital.",
  DOCS_PENDING_INFO: "Sube los documentos que te pediremos a continuación.",
  DOCS_VALIDATION_PENDING: "Validar documentación",
  DOCS_VALIDATION_PENDING_INFO:
    "Dirígite al mostrador de financiación y valida tu documentación enseñando el QR que te hemos enviado por email.",
  SIGNATURE_COMPLETED: "Contrato firmado",
  SIGNATURE_PENDING: "Firmar el contrato",
  SIGNATURE_PENDING_INFO: "Revisa el contrato y fírmalo digitalmente.",
  SIGNATURE_PENDING_BY_MAIL_INFO:
    "Recibirás el contrato para firmarlo digitalmente.",
  SIGNATURE_PENDING_BY_MAIL_INFO_MESSAGE:
    "Revisa tu correo electrónico y firma desde cualquier dispositivo.",
  SIGNATURE_PENDING_BY_APP_INFO:
    "Podrás firmar el contrato en el siguiente paso.",
  PREAPPROVED_DOCUMENTS_UPLOADED_SIGNATURE_NOT_AVAILABLE:
    "Documentación subida correctamente.",
  SIGNATURE_MODULE_YET_NOT_AVAILABLE: (
    <>
      <p>El proceso de firma digital todavía no está disponible.</p>
      <p>
        Te informaremos por correo electrónico tan pronto como sea posible
        firmar el contrato de forma digital.
      </p>
    </>
  ),
  YOU_CAN_SAFELY_CLOSE_THIS_WINDOW: (
    <p>
      <b>Pronto recibirás una respuesta en tu email.</b>
      <br /> Ya puedes cerrar esta ventana con seguridad.
    </p>
  ),

  RECEIVE_CONTRACT_TO_SIGN:
    "Recibirás el contrato para firmarlo digitalmente desde cualquier dispositivo.",
  INFORMATION_IN_CASE_OF_APPROVAL:
    "En caso de que la entidad financiera necesite más documentación adicional, te informaremos",
  SEND_DOCUMENTATION_NEEDED:
    "Necesitas aportar la documentación requerida. ¡Hazlo ahora!",
  UPLOAD_DOCS_NOW: "Subir documentación ahora",
  RETURN_TO_MERCHANT: "Volver al comercio",
  REDIRECTING_TO_MERCHANT: "Redirigiendo al comercio",
  SIGN_NOW: "Proceder a firma",
  SYSTEM_FAILURE_DETECTION:
    "Tu perfil no se adapta a las políticas de riesgo de las entidades financieras colaboradoras.",
  DOCUMENTATION_UPLOADED_SUBTITLE:
    "Has subido toda la documentación correctamente.",
  DOCUMENTATION_UPLOADED_DETAIL:
    "¡Estáte atent@! Te mantendremos informado por email.",
  PLEASE_WAIT: "Por favor espera un momento",
  INFO_SYNC:
    "Por favor espera mientras actualizamos el estado. Este proceso puede durar unos segundos.",

  // SummaryView
  LETS_START: "Vamos a ello",
  ID: "Identificación",
  ID_VERIFICATION: "Comprobación de identidad",
  FINANCES: "Finanzas",
  FINANCE_PROFESSIONAL_INFO: "Datos financieros y profesionales",
  LOAN_ADJUSTMENT: "Ajuste y evaluación de tu préstamo",
  THIS_IS_THE_PROCESS: "Así será el proceso de solicitud para tu préstamo",
  CHECK_ID: "Comprobar identidad",
  CHECK_ID_AGAIN:
    "Necesitamos volver a realizar tu comprobación de identidad automática",
  RESUME_PROCESS:
    "Puedes reanudar el proceso de solicitud desde donde lo has dejado",
  RESUME: "Reanudar",
  RETRY: "Volver a intentar",
  FROM: "Desde",
  FROM_LOWERCASE: "desde",

  // KycAutomatic
  VIDEO_ID: "Identificación por video",
  SELECT_DOCUMENT_TYPE: "Selecciona el tipo de documento",
  REMEMBER_TO_ACTIVATE_PERMISSIONS:
    "Recuerda activar los permisos de cámara y micrófono en tu dispositivo. Ten a mano el documento de identidad en un entorno bien iluminado.",
  START_ID: "Iniciar identificación",
  FOLLOW_INSTRUCTIONS: "Sigue las instrucciones",
  CONSTENT_VIDEO_ID:
    "Acepto que se realice la video-identificación y se recaben datos biométricos e indicativos con la finalidad de certificar mi identidad. Para más información ver",
  MANUAL_IDENTIFICATION: "Identificación manual",
  NO_ELECTRONIC_ID_FOR_PASSPORT_MESSAGE:
    "A continuación, deberás introducir tu información personal y subir una foto de la página bio del pasaporte.",
  WELL_DONE: "¡Muy bien!",
  YOUR_VIDEO_ID_HAS_BEEN_SUCCESSFULLY_RECORDED:
    "Has completado correctamente el proceso de video identificación",
  YOU_CAN_SAFELY_CLOSE_THIS_TAB: "Ya puedes cerrar esta pestaña con seguridad.",
  AN_ERROR_OCURRED_DURING_THE_VIDEO_ID:
    "Ha ocurrido un error durante el proceso de registro de la video identificación",
  PLEASE_TRY_AGAIN:
    "Por favor, vuelve a repetir el proceso clicando en el botón de abajo",
  REPEAT_VIDEO_ID: "Repetir identificación",
  SUNDAY: "domingo",
  FRIDAY: "viernes",
  VIDEO_ID_ASSISTANCE_MESSAGE:
    "Si estás teniendo dificultades con la identificación por videollamada, puedes llamarnos al $v1 de lunes a $v2 de $v3 a $v4 para que te ayudemos y guiemos durante el proceso. Lamentamos las molestias y agradecemos tu paciencia.",
  // ElectronicId
  ELECTRONIC_ID_ERROR_TITLE: "Ha ocurrido un problema",

  ELECTRONIC_ID_HTTPS_REQUIRED:
    'Por favor, revisa que la dirección (URL) desde la que estás accediendo comienza por "https://..."',
  ELECTRONIC_ID_IMAGE_BLURRED:
    "Limpia el objetivo de la cámara o prueba desde otro dispositivo con mayor calidad de imagen.",
  ELECTRONIC_ID_AUTHORIZATION_INVALID:
    "Limpia el objetivo de la cámara o prueba desde otro dispositivo con mayor calidad de imagen.",
  ELECTRONIC_ID_MAX_LENGTH_EXCEEDED:
    "Trata de mejorar el entorno de grabación (lugar con iluminación, sin sombras, tener el documento original a mano). También puedes probar desde otro dispositivo con mayor calidad de imagen.",
  ELECTRONIC_ID_DOCUMENT_TAMPERED:
    "Recuerda que debes utilizar el documento original y en buen estado. No puedes usar una fotocopia.",
  ELECTRONIC_ID_ERROR:
    "Trata de mejorar el entorno de grabación (lugar con iluminación, sin sombras, tener el documento original a mano). También puedes probar desde otro dispositivo con mayor calidad de imagen. Recuerda que debes utilizar el documento original y en buen estado. No puedes usar una fotocopia.",
  ELECTRONIC_ID_LUMINANCE_TOO_HIGH:
    "Prueba desde otro lugar con otra iluminación y sin sombras. También puedes intentarlo desde otro dispositivo con mejor calidad de imagen.",
  ELECTRONIC_ID_LUMINANCE_TOO_LOW:
    "Parece que no hay suficiente luz. Por favor, busca un lugar mejor iluminado. También puedes intentarlo desde otro dispositivo con mejor calidad de imagen.",
  ELECTRONIC_ID_USER_ABORTED: "Por favor, inténtalo de nuevo.",
  ELECTRONIC_ID_INACTIVE_USER_ABORTED: "Por favor, inténtalo de nuevo.",
  ELECTRONIC_ID_TYPE_INVALID:
    "Recuerda que debes utilizar el documento original y en buen estado. No puedes usar una fotocopia.",
  ELECTRONIC_ID_DOCUMENT_SIDES_MISMATCH:
    "Asegúrate de que utilizas un único documento del que figuras como titular.",
  ELECTRONIC_MICROPHONE_NOT_FOUND:
    "Debes activar el permiso del micrófono desde los Ajustes de tu dispositivo o desde la configuración del buscador. También puedes intentarlo desde otro dispositivo.",
  ELECTRONIC_ID_MAX_FPS_EXCEEDED:
    "Inténtalo desde otro dispositivo/navegador. Aségurate que estás conectado a una red con buena conexión y estás utilizando un navegador recomendado (Google Chrome, Mozilla Firefox, Microsoft Edge y Safari (iOS).",
  ELECTRONIC_ID_CAMERA_INVALID_REQUIREMENTS:
    "Inténtalo desde otro dispositivo con otro modelo de cámara. Inténtalo desde otro dispositivo/navegador. Aségurate que estás conectado a una red con buena conexión y estás utilizando un navegador recomendado (Google Chrome, Mozilla Firefox, Microsoft Edge y Safari (iOS).",
  ELECTRONIC_ID_DOCUMENT_GLARED:
    "Inténtalo de nuevo evitando los reflejos sobre el documento. Recuerda que debes utilizar el documento original y en buen estado. No puedes usar una fotocopia.",
  ELECTRONIC_ID_DEVICE_NOT_SUPPORTED: "Inténtalo desde otro dispositivo.",
  ELECTRONIC_ID_PERMISSIONS_REFUSED: "Inténtalo desde otro dispositivo.",
  ELECTRONIC_ID_FACES_MISMATCH:
    "La persona titular del documento debe ser quien lleve a cabo el proceso de identificación.",
  ELECTRONIC_ID_MULTIPLE_FACES:
    "Asegúrate de que sólo el titular del documento está presente durante la identificación.",
  ELECTRONIC_ID_CAMERA_RESOLUTION_TOO_LOW:
    "Prueba desde otro dispositivo con mayor resolución.",
  ELECTRONIC_ID_CONNECTION_INTERRUPTED:
    "Problemas de conexión. Prueba desde otro lugar o conectándote a otra red.",
  ELECTRONIC_ID_CONNECTION_ERROR:
    "Prueba desde otro lugar o conectándote a otra red. Utiliza un navegador recomendado (Google Chrome, Mozilla Firefox, Microsoft Edge y Safari (iOS).",
  ELECTRONIC_ID_VIDEO_ID_REJECTED: "",
  ELECTRONIC_ID_DOCUMENT_NOT_ALLOWED:
    "Recuerda que debes utilizar el documento original y en buen estado. No puedes usar una fotocopia.",
  ELECTRONIC_ID_CAMERA_NOT_FOUND:
    "Debes activar el permiso de la cámara desde los Ajustes de tu dispositivo o desde la configuración del buscador.",
  ELECTRONIC_ID_ACCESS_TOKEN_INVALID: "",
  ELECTRONIC_ID_AGENT_ABORTED: "",
  ELECTRONIC_ID_VIDEO_ID_NOT_SUPPORTED:
    "Prueba desde otro navegador. Navegadores recomendados: Google Chrome, Mozilla Firefox, Microsoft Edge y Safari (iOS).",
  ELECTRONIC_ID_BARCODE_ILLEGIBLE:
    "Limpia el objetivo de la cámara o prueba desde otro dispositivo con mayor calidad de imagen.",
  ELECTRONIC_ID_RTC_CONNECTION_NOT_AVAILABLE:
    "Intántalo desde otro dispositivo/navegador. Aségurate que estás conectado a una red con buena conexión y estás utilizando un navegador recomendado (Google Chrome, Mozilla Firefox, Microsoft Edge y Safari (iOS).",
  ELECTRONIC_ID_BANDWITH_TOO_LOW:
    "Prueba desde otro lugar o conectándote a otra red. Utiliza un navegador recomendado (Google Chrome, Mozilla Firefox, Microsoft Edge y Safari (iOS).",
  ELECTRONIC_ID_HOLOGRAM_NOT_DETECTED: "",
  ELECTRONIC_ID_CONNECTION_UNSTABLE:
    "Prueba desde otro lugar o conectándote a otra red. Utiliza un navegador recomendado (Google Chrome, Mozilla Firefox, Microsoft Edge y Safari (iOS).",
  ELECTRONIC_ID_CAPTCHA_INVALID:
    "Prueba desde otro navegador. Navegadores recomendados: Google Chrome, Mozilla Firefox, Microsoft Edge y Safari (iOS).",
  ELECTRONIC_ID_AUTHORIZATION_REUSED: "",
  ELECTRONIC_ID_VIDEO_ID_BAD_REQUEST:
    "Si el problema persiste, prueba desde otro lugar o conectándote a otra red. Utiliza un navegador recomendado (Google Chrome, Mozilla Firefox, Microsoft Edge y Safari (iOS).",
  ELECTRONIC_ID_RTC_CONNECTION_LOST:
    "Prueba desde otro lugar o conectándote a otra red. Utiliza un navegador recomendado (Google Chrome, Mozilla Firefox, Microsoft Edge y Safari (iOS).",
  ELECTRONIC_ID_BARCODE_NOT_DETECTED:
    "Recuerda que debes utilizar el documento original y en buen estado. No puedes usar una fotocopia. También puedes intentarlo desde otro dispositivo con mejor calidad de imagen.",
  ELECTRONIC_ID_FACE_SCAN_DISCONTINUITY:
    "Asegúrate de que el proceso se realiza de forma continuada por el titular del documento. Recuerda que debes utilizar el documento original y en buen estado. No puedes usar una fotocopia.",
  ELECTRONIC_ID_USER_UNDERAGE:
    "La mayoría de edad es obligatoria para poder continuar con el proceso.",
  ELECTRONIC_ID_CAMERA_UNAVAILABLE:
    "Asegúrate de que la cámara no está siendo usada por otra aplicación. Por favor, cierra otras aplicaciones que tengas abiertas en tu dispositivo.",
  ELECTRONIC_ID_DOCUMENT_EXPIRED:
    "Debes utilizar un documento vigente a día de hoy.",
  ELECTRONIC_ID_MICROPHONE_PERMISION_DENIED:
    "Debes activar el permiso del micrófono desde los Ajustes de tu dispositivo o desde la configuración del buscador.",
  ELECTRONIC_ID_DOCUMENT_WRONG_SIDE:
    "Repite el proceso siguiendo las indicaciones. Recuerda que primero debes mostrar la parte delantera del documento y después la parte trasera.",
  ELECTRONIC_ID_SMILE_ID_NOT_VALIDATED:
    "Asegúrate de que el proceso se realiza de forma continuada por la persona titular del documento.",
  ELECTRONIC_ID_TYPE_UNAUTHORIZED:
    "Recuerda que debes utilizar el documento original y en buen estado. No puedes usar una fotocopia. El titular debe ser mayor de edad y el documento debe estar vigente.",
  ELECTRONIC_ID_CONNECTION_LOST:
    "Prueba desde otro lugar o conectándote a otra red. Utiliza un navegador recomendado (Google Chrome, Mozilla Firefox, Microsoft Edge y Safari (iOS).",
  ELECTRONIC_ID_SURFACE_NOT_REFLECTIVE:
    "Recuerda que debes utilizar el documento original y en buen estado. No puedes usar una fotocopia. El sistema debe poder verificar todos los elementos de seguridad del documento.",
  ELECTRONIC_ID_NO_AGENT_AVAILABLE: "",
  ELECTRONIC_ID_PERMISSION_DENIED:
    "Debes activar los permisos de micrófono y cámara desde los Ajustes de tu dispositivo o desde la configuración del buscador.",
  ELECTRONIC_ID_BROWSER_NOT_SUPPORTED:
    "Prueba desde otro navegador. Navegadores recomendados: Google Chrome, Mozilla Firefox, Microsoft Edge y Safari (iOS).",
  ELECTRONIC_ID_DOCUMENT_ILLEGIBLE:
    "Limpia el objetivo de la cámara o prueba desde otro dispositivo. Recuerda que debes utilizar el documento original y en buen estado. No puedes usar una fotocopia.",
  ELECTRONIC_ID_USER_INACTIVE: "",
  ELECTRONIC_ID_TYPE_NOT_SUPPORTED_IN_WEB_BROWSER:
    "Prueba desde otro navegador. Navegadores recomendados: Google Chrome, Mozilla Firefox, Microsoft Edge y Safari (iOS).",
  ELECTRONIC_ID_RECORDING_ERROR:
    "Por favor, inténtalo de nuevo. Recuerda que debes tener conexión a internet y estar en un sitio con iluminación. Utiliza un navegador recomendado (Google Chrome, Mozilla Firefox, Microsoft Edge y Safari (iOS).",
  ELECTRONIC_ID_FACE_SPOOFING:
    "Asegúrate de que el proceso se realiza de forma continuada por el titular del documento. Recuerda que debes utilizar el documento original y en buen estado. No puedes usar una fotocopia. El sistema debe poder verificar todos los elementos de seguridad del documento.",
  ELECTRONIC_ID_DOCUMENT_SIDES_MATCH_NOT_POSSIBLE:
    "Asegúrate de que utilizas un único documento del que figuras como titular. Recuerda que debes utilizar el documento original y en buen estado. No puedes usar una fotocopia.",
  ELECTRONIC_ID_RTC_CONNECTION_ERROR:
    "Intántalo desde otro dispositivo/navegador. Aségurate que estás conectado a una red con buena conexión y estás utilizando un navegador recomendado (Google Chrome, Mozilla Firefox, Microsoft Edge y Safari (iOS).",
  ELECTRONIC_ID_CAMERA_PERMISSION_DENIED:
    "Debes activar el permiso de la cámara desde los Ajustes de tu dispositivo o desde la configuración del buscador.",
  ELECTRONIC_ID_LIVENESS_NOT_DETECTED: "",

  // KycManual
  [DocumentType.NIF]: "DNI español",
  [DocumentType.NIE_EU]: "NIE dentro Unión Europea (sin foto)",
  [DocumentType.NIE_NON_EU]: "NIE fuera Unión Europea (con foto)",
  [DocumentType.PASSPORT]: "Pasaporte",
  DNI_ES: "DNI español",
  NIE_UE: "NIE dentro Unión Europea (sin foto)",
  NIE_NON_UE: "NIE fuera Unión Europea (con foto)",
  PASSPORT: "Pasaporte",
  SELECT_YOUR_ID: "Selecciona tipo de documento",
  DOCUMENT_NUMBER: "Número de documento",
  INVALID_DOCUMENT_NUMBER: "Número de documento inválido",
  EXPIRATION: "Fecha de validez",
  CONTRACT_EXPIRATION: "Fecha de fin del trabajo actual",
  DOCUMENT_EXPEDITOR: "País de expedición",
  NATIONALITY: "Nacionalidad",
  ID_INFORMATION: "Información de identidad",
  DOCUMENT_TYPE: "Tipo de documento",
  NAME_SURNAME: "Nombre y apellidos",
  PERSONAL_INFORMATION: "Información personal",
  BASIC_ID_INFORMATION: "Informacion básica de identidad",
  FIRST_NAME: "Nombre",
  LAST_NAME: "Apellidos",
  GENDER: "Género",
  MALE: "Hombre",
  FEMALE: "Mujer",
  BIRTH_DATA: "Datos de nacimiento",
  BIRTHDATE: "Fecha de nacimiento",
  BIRTH_CITY: "Ciudad de nacimiento",
  BIRTH_PROVINCE: "Provincia de nacimiento",
  BIRTH_INFO: "Lugar y fecha de nacimiento",
  TAKE_PICTURE: "Tomar fotografía",
  PREPARING_CAMERA: "Preparando cámara",
  ID_DOC_CAMERA_ERROR_TITLE: "Cámara no disponible",
  ID_DOC_CAMERA_ERROR_BODY:
    "No hemos podido acceder a tu cámara. Permite los permisos de cámara en la configuración del navegador/dispositivo o elige Subir imágenes para continuar.",
  SELECT_FROM_GALLERY: "o seleccionar de la galería",
  IMAGE_ID: "Imagen del documento",
  DNI_ES_FRONT: "Foto frente del DNI",
  DNI_ES_BACK: "Foto reverso del DNI",
  NIE_UE_FRONT: "Foto frente del NIE",
  NIE_UE_BACK: "Foto reverso del NIE",
  NIE_NON_UE_FRONT: "Foto frente del NIE",
  NIE_NON_UE_BACK: "Foto reverso del NIE",
  PICTURE_INSTRUCTIONS:
    "Por favor, sube la fotografía o imagen del documento de cerca, centrada, bien iluminada y sin cortes.",
  PICTURE_INSTRUCTIONS_MOBILE:
    "Por favor, intenta tomar la fotografía del documento de cerca, centrada y sin cortes. Te recomendamos un entorno bien iluminado para que los datos sean legibles.",
  INVALID_DATE: "Fecha no válida",
  PAST_DATE_NOT_ALLOWED: "Fecha pasada no válida",
  FUTURE_DATE_NOT_ALLOWED: "Fecha futura no válida",
  UNDERAGE_NOT_ALLOWED: "Debes ser mayor de edad",
  LAST_NAME_TWO_WORDS_REQUIRED: "Introduce los dos apellidos",
  DOCUMENT_TYPE_SHORT_NIF: "DNI",
  DOCUMENT_TYPE_SHORT_NIE_EU: "NIE (UE)",
  DOCUMENT_TYPE_SHORT_NIE_NON_EU: "NIE",
  KYC_VIDEO_VERIFICATION_CONTEXT:
    "Para acreditar que eres el titular del documento que has verificado anteriormente, realizaremos una breve vídeo-identificación.",
  UserDetailsDocumentNumberDoesNotMatchKycException:
    "El documento grabado en el vídeo no coincide con los datos del formulario. Por favor, repite el proceso con el documento correcto.",
  VIDEO_ID_PENDING_INFO:
    "Verifica la autenticidad de tu documento de identidad",
  // AdditionalData
  IMAGE_ID_NIE_EU: "Imagen del pasaporte",
  PASSPORT_FRONT: "Foto página bio del pasaporte",
  PASSPORT_PICTURE_INSTRUCTIONS_MOBILE:
    "Por favor, intenta tomar la fotografía de la página bio del pasaporte de cerca, centrada y sin cortes. Te recomendamos un entorno bien iluminado para que los datos sean legibles.",
  PASSPORT_PICTURE_INSTRUCTIONS:
    "Por favor, sube la fotografía o imagen de la página bio del pasaporte de cerca, centrada, bien iluminada y sin cortes.",
  UPLOAD_PICTURE: "Subir imagen",
  UPLOAD_PICTURES: "Subir imágenes desde dispositivo",
  UPLOAD_PICTURES_ACTION: "Subir imágenes",
  front: "delantera",
  back: "trasera",
  LOAD_PICTURE: "Cargar imagen",
  UPLOAD_PICTURE_FORMAT_HINT: "Solo se permiten imágenes JPG o PNG.",
  UPLOAD_PICTURE_FORMAT_ERROR:
    "Formato no válido. Por favor, sube una imagen JPG o PNG.",

  ADDITIONAL_INFORMATION: "Información adicional",
  CURRENT_RESIDENCE_ADDRESS: "Dirección actual de residencia",
  FAMILY_SITUATION: "Situación familiar",
  ADDRESS: "Dirección",
  ADDRESS_FLOOR: "Piso",
  ADDRESS_DOOR: "Puerta",
  FLOOR_NUMBER: "Piso $v1",
  DOOR_NUMBER: "Puerta $v1",
  ADDRESS_DIALOG_TITLE: "Dirección actual de residencia",
  CONFIRM_ADDRESS: "Confirmar dirección",
  EDIT_ADDRESS: "Modificar dirección",
  ADDRESS_DIALOG_ERROR_TITLE: "Selecciona una opción",
  ADDRESS_CONTINUE_MESSAGE:
    "Escribe tu dirección y selecciona una de las opciones disponibles del desplegable para poder avanzar.",
  ADDRESS_DIALOG_ERROR_MESSAGE:
    "No se ha podido geolocalizar tu dirección. Por favor verifica que sea correcta, editando el campo y seleccionando una opción.",
  ADDRESS_DIALOG_SPANISH_ADDRESS_REMINDER:
    "Recuerda que tu dirección tiene que estar ubicada en territorio español.",
  ADDRESS_DIALOG_WARNING_MESSAGE:
    "Parece que a esta dirección le falta un número de calle. Por favor, verifica que es correcta.",
  ADDRESS_DIALOG_SUCCESS_MESSAGE: (
    <div>
      La dirección parece válida.
      <br />
      Haz click en <strong>Confirmar dirección</strong> si es correcta.
    </div>
  ),
  IN_SPAIN: "(calle y número, dentro de España)",
  STREET_AND_NUMBER: "(calle y número)",
  SPAIN: "España",
  ADDRESS_ERROR_MISSING_STREET_NUMBER:
    "Por favor, introduce el número de calle en la dirección.",
  ADDRESS_ERROR_MISSING_POSTAL_CODE:
    "No hemos podido detectar el código postal. Por favor, intenta ajustar la dirección introducida.",
  ADDRESS_ERROR_MISSING_GENERAL_ERROR:
    "La dirección no parece válida. Por favor, intenta ajustar la dirección introducida",

  //AUTOCOMPLETE ADDRESS
  UPDATING_FIELDS: "Actualizando campos...",
  LOADING: "Cargando...",
  COMPLETE_ADDRESS_MANUALLY: "Completar dirección manualmente",
  STREET_NAME: "Nombre calle",
  STREET_NUMBER: "Número calle",
  FLOOR: "Piso",
  DOOR: "Puerta",
  POSTAL_CODE: "Código postal",
  INVALID_POSTAL_CODE: "Código postal inválido",
  PROVINCE: "Provincia",
  COUNTRY: "País",
  CITY: "Ciudad",
  REGION: "Región",
  LATITUDE: "Latitud",
  LONGITUDE: "Longitud",
  BUILDING_LABEL: "Bloque / Escalera",
  NO_OPTIONS_TO_DISPLAY: "No hay opciones disponibles",
  FIELD_VALUE_MUST_BE_BELOW_X_CHAR:
    "El valor del campo no puede superar $v1 caracteres",
  FIELD_VALUE_MUST_NOT_CONTAIN_SPACES:
    "El valor del campo no puede contener espacios",
  SEARCH_RESULTS: "Resultados del autocompletado:",
  SELECTED_ADDRESS: "Dirección seleccionada",
  FILL_ADDRESS_VALUES: "Rellenar datos de dirección:",
  EDIT_ADDRESS_VALUES: "Editar datos de dirección:",
  EDIT: "Editar",
  SEARCH_AGAIN: "Volver a buscar",
  CONFIRM_DATA: "Confirmar datos",

  ADDRESS_AUTOCOMPLETE: "Autocompletar dirección",
  ADDITIONAL_ADDRESS: "Datos complementarios de dirección",

  HOME_INFO: "Datos del domicilio actual",
  MY_CURRENT_ADDRESS_IS: "Mi domicilio actual es",
  OWNERSHIP: "De mi propiedad",
  RENT: "Alquilado",
  LEASING: "Propiedad/Alquiler empresa",
  PARTNER: "Propiedad de cónyuge",
  PARENTS: "Propiedad de padres",
  USUFRUCT: "Usufructo",
  OTHER: "Otro",
  HOUSE: "Casa",
  APARTMENT: "Apartamento",
  ADDRESS_START_DATE: "Fecha de entrada al domicilio actual",
  HOME_EXPENSES_AMOUNT_RENT: "€/mes de alquiler",
  PROPERTY_TYPE: "Tipo de propiedad",
  MORTGAGE: "Con hipoteca",
  HOME_EXPENSES_AMOUNT: "€/mes de hipoteca",
  YOUR_PART: "(tu parte proporcional)",
  MORTGAGE_AMOUNT_GREATER_THAN_VALUE:
    "El valor de la hipoteca deberá ser superior a $v1 €",
  RENT_AMOUNT_GREATER_THAN_VALUE:
    "El valor del alquiler deberá ser superior a $v1 €",
  PRIVATE_CONTRACT: "Con contrato privado",
  PUBLIC_DEED: "Con escritura pública",
  SOCIAL_HOUSING: "Vivienda social",
  OTHERS: "Otros",

  MARITAL_STATUS: "Estado civil",
  MARITAL_REGIME: "Régimen matrimonial",
  MARRIED: "Casado/a",
  SEPARATED: "Separado/a",
  SINGLE: "Soltero/a",
  WIDOWED: "Viudo/a",
  DIVORCED: "Divorciado/a",
  SEPARATED_IN_FACT: "Separado/a de hecho️",
  SIMILAR_SITUATION_TO_MARRIED: "Situación similar al matrimonio",
  MATRIMONIAL_ASSETS: "Con régimen de gananciales",
  SEPARATE_PROPERTY: "Con separación de bienes",
  CHILD_SUPPORT_NUMBER: "Número de hijos a cargo",

  CUPS_SUPPLY_CODE: "Código suministro CUPS",
  CUPS_CODE: "Código CUPS",
  WHAT_IS_CUPS: "¿Qué es el código CUPS?",
  HOW_TO_FIND_CUPS: "¿Cómo encontrar mi código CUPS?",
  CUPS_CODE_EXPLANATION: (
    <div>
      <p>
        El Código Universal de Punto de Suminstro, también denominado CUPS, es
        el código que identifica cada punto de suministro de la red de gas
        natural y electricidad en España.
      </p>
      <p>
        La diferencia principal entre el código CUPS de la luz y del gas natural
        reside en que el código de la luz empieza por ES00 y el del gas natural
        comienza por ES02, aunque puede variar en función de la distribuidora.
      </p>
    </div>
  ),
  HOW_TO_FIND_CUPS_EXPLANATION_1: (
    <div>
      <strong>En la factura de gas o de la luz: </strong>
      <span>&nbsp;</span>
      El código CUPS de la instalación viene en todas las facturas y este código
      no varia.
    </div>
  ),
  HOW_TO_FIND_CUPS_EXPLANATION_2: (
    <div>
      <strong>Llamando a la distribuidora</strong>
      <span>&nbsp;</span>
      En el caso de no disponer de una factura anterior, se puede obtener a
      través de la distribuidora de la zona, aportando la dirección exacta del
      punto de suministro y los datos personales del titular.
    </div>
  ),
  INVALID_CUPS_NUMBER: "Número CUPS inválido",
  DOCUMENT_NUMBER_VALIDATION_FAIL:
    "Los datos de la propuesta enviados por el comercio no coinciden con la video-identificación realizada.",
  PLEASE: "Por favor",
  RESEND_PROPOSAL: "Habla con tu comercio para enviar una nueva solicitud",
  RETRY_VIDEO_ID:
    "Realiza una nueva video-identificación con los datos aportados por el comercio",

  // Eurobits
  FINANCIAL_DATA: "Datos financieros",
  CONNECT_WITH_YOUR_BANK: "Conecta con tu banco",
  UPLOAD_DOCUMENTATION: "Aportar documentación",
  START_CONNECTION_WITH_YOUR_BANK: "Conectar con tu banco",
  GET_INFO_BANK:
    "Conseguimos la información que necesitamos conectando con tu banco.",

  EUROBITS_INFO:
    "Este proceso se realiza a través de Eurobits Technologies y es totalmente privado y confidencial. ",
  CONNECT_BANKING_INFO:
    "Conecta con tu banco con el acceso habitual a tu banca online",
  ONLY_WHAT_WE_NEED: "Solo lo que necesitamos",
  EUROBITS_INFO_PHRASE1: "Solo se analiza tu capacidad financiera",
  EUROBITS_INFO_PHRASE2:
    "No se realizará ningún tipo de cargo en tu cuenta bancaria",
  ONLINE_BANK: "Sin papeleo",
  TRADITIONAL: "Con papeleo",
  PAPERLESS_EASY_AND_FAST: "Sin papeleo, fácil y rápido",
  PAPERLESS: "Sin papeleo",
  EASY_AND_FAST: " Fácil y rapido",
  TOTALLY_SAFE: "Totalmente seguro",
  SELECT_BANK_AND_LOGIN:
    "Selecciona y haz login en tu banca online. Recuerda que no es el PIN de tu tarjeta.",
  NO_PASSWORD_SAVED:
    "En ningún momento tenemos acceso ni guardamos tu contraseña.",
  NO_PIN: "Recuerda que no es el PIN de la tarjeta",
  TRADITIONAL_PATH: "Prefiero declarar mis ingresos por la vía tradicional",
  LONGER_PROCESS:
    "Este proceso llevará algo más de tiempo y tendrás que esperar para saber el estado de la solicitud",
  DOCUMENTATION_NEEDED:
    "Deberás aportar documentos que reflejen los ingresos declarados así como justificante de titularidad bancaria",

  // Errors
  ERROR_RNCP_TITLE: (
    <div>
      Lo sentimos, no hemos encontrado{" "}
      <strong> ninguna cuenta de pago. </strong>
    </div>
  ),
  ERROR_RNCP_TEXT:
    "Por favor, vuelve a reintentar el proceso de conexión bancaria asegurándote de proporcionar una cuenta de pago válida.",
  ERROR_RIDN_TITLE: (
    <div>
      Lo sentimos,{" "}
      <strong> el titular de la cuenta proporcionada difiere</strong> al del
      préstamo.
    </div>
  ),
  ERROR_RIDN_TEXT:
    "Por favor, vuelve a reintentar el proceso de conexión bancaria asegurandote de proporcionar una cuenta con el mismo titular que la persona a la que va dirigida el préstamo.",
  ERROR_RECI_TITLE: (
    <div>
      Lo sentimos,{" "}
      <strong> no es posible asegurar la titularidad de esta cuenta.</strong>
    </div>
  ),
  ERROR_RECI_TEXT:
    "Lamentablemente no podemos formalizar el préstamo con los datos introducidos. Si lo deseas, puedes volver a reintentarlo con una conexión bancaria distinta.",
  ERROR_BR_DEFAULT_TITLE: "Lo sentimos, ha ocurrido un error en el proceso.",
  ERROR_BR_DEFAULT_TEXT:
    "Por favor, vuelve a reintentar el proceso de conexión bancaria.",

  // CashInCashOutMethod
  SELECT_YOUR_BANK_ACCOUNT: "Selecciona la cuenta de domiciliación",

  // Professional Data
  PROFESSIONAL_DATA: "Datos profesionales",
  EMPLOYMENT_STATUS: "Situación laboral",
  PROFESSIONAL_POSITION: "Posición",
  COMPANY_INFO: "Datos de la compañía donde trabajas",
  COMPANY_ACTIVITY: "Actividad de la compañía",
  COMPANY_CITY: "Ciudad de la compañía",
  COMPANY_NAME: "Nombre de la compañía",
  COMPANY_YEAR: "Fecha de inicio del trabajo actual",
  INDEFINITE_EMPLOYED: "Trabajo con contrato indefinido",
  TEMPORARY_EMPLOYED: "Trabajo con contrato temporal",
  FIXED_DISCONTINUOUS_EMPLOYED: "Trabajo con contrato fijo discontinuo",
  CIVIL_SERVANT: "Funcionario/a",
  SELF_EMPLOYED: "Autónomo/a",
  TRAINEE: "Becario / En prácticas",
  CASUALTY_WORKER: "Temporero/a",
  UNEMPLOYED: "En paro",
  RETIRED: "Retirado/a",
  PENSIONER: "Pensionista",
  STUDENT: "Estudiante",
  RENTIER: "Rentista",
  WIDOWS_INCOME: "Renta de viudedad",
  OTHER_PROFESSION: "Cuidado del hogar",
  ADMINISTRATIVE: "Administrativo/a",
  MANAGING_DIRECTOR: "Directivo/a",
  MANAGER: "Gerente",
  COMPANY_OWNER: "Propietario/a / Administrador/a empresa",
  TECHNICIANS_AND_PROFESSIONAL: "Técnico/a o Profesional",
  SHOP_ASSISTANT: "Dependiente / Camarero/a",
  COMMERCIAL_AND_SALES_PERSON: "Comercial / Ventas",
  LABOR_WORKER: "Operario / Obrero",
  ENGINEER: "Ingeniero/a",
  ARCHITECT: "Arquitecto/a",
  LAWYER_OR_NOTARY_ATTORNEY: "Abogado/a o notario/a",
  DOCTOR_OR_DENTIST: "Profesionales de la salud",
  PHARMACEUTICAL: "Farmacéutico/a",
  VETERINARY: "Veterinario/a",
  TEACHER: "Maestro/a",
  JOURNALIST: "Periodista",
  FARMER_OR_RANCHER: "Agricultor/a o ganadero/a",
  TRANSPORTER: "Transportista",
  PROFESSIONAL_ATHLETE: "Atleta profesional",
  ARTIST: "Artista",
  RELIGIOUS: "Religioso/a",
  POLICE_AND_MILITARY: "Policía / Ejército",
  DIPLOMATIC: "Diplomático/a",
  CIVIL_SERVANT_A1: "Adm. público - Funcionario A1",
  CIVIL_SERVANT_A2: "Adm. público - Funcionario A2",
  CIVIL_SERVANT_B: "Adm. público - Funcionario B",
  CIVIL_SERVANT_C1: "Adm. público - Funcionario C1",
  CIVIL_SERVANT_C2: "Adm. público - Funcionario C2",
  CIVIL_SERVANT_E: "Adm. público - Funcionario E",
  CIVIL_SERVANT_G1: "Adm. público - Funcionario G1",
  CIVIL_SERVANT_G2: "Adm. público - Funcionario G2",
  CIVIL_SERVANT_G3: "Adm. público - Funcionario G3",
  CIVIL_SERVANT_G4: "Adm. público - Funcionario G4",
  CIVIL_SERVANT_G5: "Adm. público - Funcionario G5",
  AGRICULTURE_LIVESTOCK_FISHERIES: "Agricultura / Ganadería / Pesca",
  MINING_METALLURGY: "Minería / Metalurgia",
  GROCERY: "Comestibles",
  TEXTILE_MANUFACTURE: "Textil",
  WOOD: "Maderería",
  GRAPHICS_ARTS_EDITION: "Arte gráfico / Edición",
  CHEMISTRY: "Quimica",
  MECHANICAL_MACHINERY: "Maquinaria mecánica",
  ENERGY_DISTRIBUTION_ELECTRICAL_SUPPLY: "Energética",
  OTHER_UNQUALIFIED_SERVICES: "Otro servicio no cualificado",
  OTHER_QUALIFIED_SERVICES: "Otro servicio cualificado",
  BUILDING: "Construcción",
  COMMERCE: "Comercio",
  PEDDLING: "Venta ambulante",
  TRANSPORT_TERRESTRIAL_MESSAGING: "Mensajería por transporte terrestre",
  OTHER_TRANSPORTS: "Otro tipo de transportista",
  TAXI_DRIVER: "Servicio de chofer / Taxi",
  TELECOMMUNICATIONS_MAIL: "Telecomunicación / Correo",
  BARS_SERVICES: "Servicios / Gastronomía",
  I_PLUS_D: "Investicación y desarrollo",
  ADVOCACY_JOURNALISM: "Periodismo / Abogacía",
  SECURE_FINANCIAL_SERVICES: "Servicios Financieros",
  FINANCIAL_SERVICES_INSURANCE: "Aseguradora",
  IT_CONSULTANT_AUDITOR: "IT / Consultoría / Auditoría",
  ARCHITECTURE_ENGINEERING: "Ingeniería / Arquitectura",
  VETERINARY_MEDICINE: "Medicina / Veterinaria",
  PUBLIC_ADMINISTRATIONS: "Administración Pública",
  ARMED_FORCES: "Fuerzas Armadas",
  EDUCATION: "Educación",
  HOLIDAY_SHOWS_SHOWS: "Vacacional / Entretenimiento",
  SPORTS: "Deporte",
  INDIVIDUAL_NET_INCOME: "Importe neto del ejercicio anterior",
  INDIVIDUAL_FINANCIAL_DATA_DATE: "Año del ejercicio anterior",
  SELF_EMPLOYED_DATA: "Datos autónomo/a",
  NON_VALID_CIF: "CIF no válido",
  COMPANY_CIF: "CIF de la compañía",

  // Validate or Edit Income
  PROVIDE_MAIN_INCOME_SOURCE: "Indica tu principal fuente de ingresos",
  INCOME_AMOUNT_GREATER_THAN_VALUE:
    "El valor de tus ingresos deberá ser superior a $v1€",
  NET_INCOME_TYPE: "Tipo de ingresos",
  MONTHLY_INCOME: "Ingresos netos mensuales",
  NUMBER_OF_PAYMENTS_PER_YEAR: "Número de pagas anuales",
  BANK_ACCOUNT_IBAN: "Cuenta de domiciliación",
  BANK_ACCOUNT_IBAN_WITHIN_SEPA: "Cuenta de domiciliación SEPA",
  BANK_ACCOUNT_USAGE_REMINDER:
    "Esta cuenta bancaria solo se utilizará para domiciliar las cuotas del préstamo",
  BANK_ACCOUNT_USAGE_REMINDER_FOR_CARD:
    "Esta cuenta se utilizará para cargar los recibos de tu financiación",
  BANK_ACCOUNT_USAGE_REMINDER_FOR_INTERNATIONAL_STUDENT:
    "Esta cuenta bancaria deberá pertenecer a una entidad dentro de la zona Euro (SEPA) y solo se utilizará para domiciliar las cuotas del préstamo",
  INVALID_IBAN_USAGE_REMINDER:
    "El número de cuenta introducido no es un IBAN válido. Por favor, introduce un IBAN válido o elige un método de pago alternativo para el pago de las cuotas.",
  IBAN_NOT_IN_SEPA_LIST_USAGE_REMINDER:
    "El número de cuenta introducido no corresponde a una entidad de la zona Euro (SEPA). Por favor, introduce un IBAN válido o elige un método de pago alternativo para el pago de las cuotas.",
  DIRECT_DEBIT_ACCOUNT: "Domiciliación",
  SALARY: "Salario",
  PENSION: "Pensión",
  UNEMPLOYMENT_BENEFIT: "Prestación de desempleo",
  OTHER_PAYMENT: "Otro tipo de ingreso",
  NO_INCOME_TITLE:
    "Lo sentimos, no hemos sido capaces de detectar ingresos en la cuenta",
  NO_INCOME_BODY:
    "No te preocupes, puedes introducir la información sobre tus ingresos de forma manual.",
  NO_INCOME_BODY_DOC:
    "Deberás subir la documentación que acredite tus ingresos al final del proceso.",
  IBAN_NOT_IN_SEPA_LIST:
    "El IBAN introducido no está en listado de paises SEPA.",
  USE_DIFFERENT_PAYMENT_METHOD: "Usar otro método de pago",
  ALTERNATIVE_PAYMENT_METHOD: "Método de pago alternativo",
  INFORMATION: "Información",
  SELECT_THIS_PAYMENT_METHOD: "Elegir este método",
  DO_NOT_HAVE_BANK_ACCOUNT_NUMBER_WITHIN_THE_SEPA_ZONE:
    "No tengo número de cuenta bancaria dentro de la zona SEPA",
  ALTERNATIVE_PAYMENT_METHOD_EXPLANATION: (
    <>
      <p>
        En caso de no disponer de número de cuenta (IBAN) dentro de la zona
        SEPA, los pagos se pueden realizar a través de Flywire, plataforma que
        permite realizar pagos globales.
      </p>
      <p>
        Si escoges este método, antes de la fecha de vencimiento de cada cuota,
        recibirás un correo electrónico con las instrucciones para completar el
        pago de forma rápida y segura.
      </p>
    </>
  ),

  //PAYMENT VIEW
  PAY_WITH_FLYWIRE: "Paga con Flywire",

  // Adjust Loan
  GOOD: "Bien hecho",
  YOUR_LOAN_RESULT: "¡Ya casi has acabado!",
  ADJUST_YOUR_QUOTA: "Ajusta la cuota que deseas pagar",
  LOAN_DURATION: "Duración",
  LOAN_TOTAL: "Importe de la compra",
  CREDIT_LINE_TOTAL: "Importe línea de crédito",
  TIN: "TIN",
  TAE: "TAE",
  TOTAL_TO_PAY: "Total a pagar",
  GRACE_PERIOD: "Carencia",
  SETUP_FEE: "Comisión de apertura",
  APPLY_FOR_LOAN: "Solicitar",
  EURO_PER_MONTH: "$v1 €/mes",
  MONEY_PER_MONTH: "$v1/mes",
  X_MONTHS: "$v1 meses",
  CONDITIONS_MULTI_PRICING_MESSAGE:
    "El importe de las cuotas puede variar según la entidad financiera. Te mostramos la mejor cuota disponible como referencia, y antes de pagar podrás revisar las condiciones finales.",
  APPLY_FOR_LOAN_BODY:
    "La solicitud sólo será vinculante cuando firmes el contrato en caso de aprobación",
  DATA_TREATMENT: "Tratamiento de datos",
  INFORMATION_ABOUT_RISK_ANALYSIS:
    "Información sobre el tratamiento de tus datos para analizar tu solvencia",
  AGREE_CONDITIONS: "Estoy de acuerdo con las condiciones",
  NEED_TO_CHOOSE_TO_CONTINUE:
    "Para poder continuar es necesario elegir 'Sí' ✓ o 'No' ✗ en todas las opciones disponibles.",
  PLEASE_WAIT_APPLICATION:
    "Por favor espera un momento, estamos procesando tu solicitud. Este proceso puede durar hasta 1 minuto.",
  TAKING_A_BIT_LONGER: "Ya casi está, por favor mantente a la espera",
  ADD_CO_BORROWER: "Añadir cotitular",
  ADD_GUARANTOR: "Añadir avalista",
  CO_BORROWER_PERSONAL_DATA: "Datos personales cotitular",
  CO_BORROWER_CONTACT_DATA: "Datos contacto cotitular",
  CO_BORROWER_FIRST_NAME: "Nombre cotitular",
  CO_BORROWER_LAST_NAME: "Apellidos cotitular",
  CO_BORROWER_DOCUMENT_NUMBER: "DNI/NIE cotitular",
  CO_BORROWER_EMAIL: "Email cotitular",
  CO_BORROWER_PHONE_NUMBER: "Móvil cotitular",
  GUARANTOR_PERSONAL_DATA: "Datos personales avalista",
  GUARANTOR_CONTACT_DATA: "Datos contacto avalista",
  GUARANTOR_FIRST_NAME: "Nombre avalista",
  GUARANTOR_LAST_NAME: "Apellidos avalista",
  GUARANTOR_DOCUMENT_NUMBER: "DNI/NIE avalista",
  GUARANTOR_EMAIL: "Email avalista",
  GUARANTOR_PHONE_NUMBER: "Móvil avalista",
  CO_BORROWER_ADDITION_INFO_MESSAGE_BODY:
    "Enviaremos un SMS y email al cotitular con un enlace para que lleve a cabo este mismo proceso de solicitud con su información.",
  GUARANTOR_ADDITION_INFO_MESSAGE_BODY:
    "Enviaremos un SMS y email al avalista con un enlace para que lleve a cabo este mismo proceso de solicitud con su información.",
  CO_BORROWER_RELATION: "Relación cotitular",
  GUARANTOR_RELATION: "Relación avalista",
  CO_BORROWER_GUARANTOR_ADDED_CORRECTLY:
    "Cotitular/Avalista añadido/a correctamente",
  GUARANTOR_ADDED_CORRECTLY: "Avalista añadido correctamente",
  borrower: "Titular",
  co_borrower: "Cotitular",
  guarantor: "Avalista",
  PARTICIPANT_ROLE: "Tipo de cotitular",
  SPOUSE: "Cónyuge",
  SIBLING: "Hermano/a",
  PARENT: "Padre/madre",
  SON: "Hijo/a",
  REST_OF_FAMILY: "Otro familiar",
  PLEASE_SELECT_DOWN_PAYMENT_AND_TERM: "Por favor, selecciona entrada y plazo",
  EMAIL_SHOULD_NOT_BE_THE_SAME_AS: "Email no puede ser el mismo que el del $v1",
  PHONE_NUMBER_SHOULD_NOT_BE_THE_SAME_AS:
    "Teléfono no puede ser el mismo que el del $v1",
  FROM_X_TO_Y_MONTHS: "De $v1 a $v2 meses",
  FROM_X_TO_Y_YEARS: "De $v1 a $v2 años",
  FROM_X_TO_Y: "De $v1 a $v2",
  TERM_MUST_BE_BETWEEN_X_AND_Y: "Permitido entre $v1 y $v2 meses",
  INVALID_TERM_VALUE: "Plazo no incluido en la tarifa",
  MONTHS: "Meses",
  YEARS: "Años",
  UP_TO: "Hasta",
  TERM: "Plazo",
  DOWN_PAYMENT: "Entrada",
  VEHICLE_PRICE_WITH_TAX: "Precio vehículo (incl. impuestos)",
  APPLICATION_AMOUNT: "Importe a financiar",
  TOTAL_PRICE_IN_SPLIT_PAYMENT: "Total a pagar",
  FEE_AMOUNT_AND_PAYMENT_PROTECTION_INSURANCE_MONTHLY_PERCENTAGE:
    "*Incluye $v1 de comisión de apertura financiada y seguro de protección de pagos $v2 mensual.",

  INCLUDES_UPFRONT_SETUP_FEE_AMOUNT: "*Incluye $v1 de comisión de apertura.",
  INCLUDES_FINANCED_SETUP_FEE_AMOUNT:
    "*Incluye $v1 de comisión de apertura financiada mensualmente.",
  DOWN_PAYMENT_OVER: "Entrada superior a",
  DOWN_PAYMENT_UNDER: "Entrada inferior a",
  INVALID_VALUE: "El valor no es válido",
  AUTO_ADJUSTED_TERM: "Plazo máximo ajustado a la antigüedad del vehículo.",
  DOWNPAYMENT_NOT_ALLOWED: "El ajuste de la entrada no está permitido.",
  LOADING_LOAN_CONDITIONS: "Cargando condiciones del préstamo...",
  CALCULATING_CONDITIONS: "Calculando condiciones...",

  // Form input help
  HELP: "Ayuda",
  CLOSE: "Cerrar",
  REQUIRED_FIELD: "Requerido",
  INVALID: "No válido",
  RECOMMENDED_FIELD: "Recomendado",
  PLEASE_COMPLETE_THIS_FIELD_CORRECTLY:
    "Por favor, completa el campo correctamente",
  INVALID_FORMAT: "Formato inválido",
  PLEASE_CHECK_INPUT_DATA: "Por favor, revisa los datos introducidos.",
  NOT_VALID_IBAN_FORMAT: "Formato de IBAN inválido",
  INVALID_SPANISH_IBAN: "Por favor, introduce un IBAN español.",

  // Documentation
  DOCUMENTATION: "Documentación",
  DOCUMENTATION_UPLOAD: "Por favor, sube los siguientes documentos",
  DOCUMENTATION_SYNC:
    "Por favor espera, actualizando la documentación. Este proceso puede durar unos segundos.",
  PENDING_DOCUMENTATION: "$v1 documentos",
  VALIDATE_DOCUMENTATION: "Subir documentos",
  VALIDATE_DOCUMENTATION_WARNING: "¡Recuerda hacer click en subir documentos!",
  FILES_WITH_INCIDENCE_WARNING:
    "¡Ooops! El documento es inválido. Por favor, vuélvelo a añadir y haz click en Hecho",
  ADD_FILE_CONFIRMATION: "Añadir nuevo documento",
  ADD_FILE_DESCRIPTION: "Se subirá el siguiente documento",
  ADD_FILE_ACTION: "Añadir documento",
  UPLOAD_FILE_ACTION_ASSERTION:
    "Por favor, confirma la documentación antes de subirla",
  INCIDENCE: "Incidencia documental",
  DONE: "Hecho",
  UPLOAD_FILE_ACTION: "Subir",
  UPLOAD_FILE_ACTION_MULTIPLE: "Subir $v1 documentos",
  UPLOAD_FILE_ACTION_SINGLE: "Subir 1 documento",
  UPLOADING_FILE_ACTION_MULTIPLE: "Subiendo $v1 documentos...",
  UPLOADING_FILE_ACTION_SINGLE: "Subiendo 1 documento...",
  BANK_ACCOUNT_OWNERSHIP_DOCUMENTATION: "Justificante de titularidad de cuenta",
  PAYROLL: "Última nómina disponible",
  PAYROLL_TWO_PREVIOUS_MONTHS: "Penúltima nómina disponible",
  PERSONAL_INCOME_TAX: "Declaración de renta anual (Modelo 100)",
  BIOMETRICS_DOCUMENT: "Documento biométrico del proceso KYC",
  DOCUMENT_ID_FRONT: "Parte delantera del DNI / NIE",
  DOCUMENT_ID_BACK: "Parte trasera del DNI / NIE",
  DOCUMENT_ID_FRONT_DNI: "Parte delantera del DNI",
  DOCUMENT_ID_BACK_DNI: "Parte trasera del DNI",
  DOCUMENT_ID_FRONT_NIE: "Parte delantera del NIE",
  DOCUMENT_ID_BACK_NIE: "Parte trasera del NIE",
  UPLOAD_DOCUMENT_ID_PICTURES: "Subir documentos de identidad",
  LOAD_DOCUMENT_ID_FRONT_NIE: "Cargar parte delantera del NIE",
  LOAD_DOCUMENT_ID_BACK_NIE: "Cargar parte trasera del NIE",
  LOAD_DOCUMENT_ID_FRONT_DNI: "Cargar parte delantera del DNI",
  LOAD_DOCUMENT_ID_BACK_DNI: "Cargar parte trasera del DNI",
  ENROLLMENT_OF_THE_STUDENT: "Justificante de matrícula",
  DOCUMENT_REQUIRED_DESCRIPTION_ENROLLMENT_OF_THE_STUDENT:
    "Justificante de matrícula del curso",
  DATE_FORMAT_YEAR: "Año",
  DATE_FORMAT_MONTH_YEAR: "Mes, año",
  DATE_FORMAT_DAY_MONTH_YEAR: "Día, mes, año",
  DATE_LOCALE: esLocale,
  SAVE_CHANGES_PROMT: "¿Deseas guardar los cambios efectuados?️",
  SAVE_CHANGES: "Guardar cambios",
  DISCARD_CHANGES: "Descartar cambios",
  DOCUMENT_ID_NUMBER_DIFFERENT_THAN_INVITATION:
    "Numero de documento no corresponde al de la propuesta de financiación",

  //CARD
  FIXED_INSTALMENT: (
    <>
      Pago aplazado
      <br />
      (revolving)
    </>
  ),
  END_OF_MONTH: "Fin de mes",
  FIXED_INSTALMENT_DESCRIPTION: (
    <>
      Con la modalidad de pago aplazada (revolving), se paga a plazos, con la
      cuota mensual que elijas, el crédito que se va utilizando con el interés
      acordado.
      <br />
      Puedes elegir el importe de la cuota que quieres pagar mensualmente en
      cualquier momento, siempre a partir de una cuota mínima que establecemos
      para evitar que la deuda se prolonga en el tiempo.
      <br />
      Recuerda que cuanto más alta sea la cuota que elijas, devolverás antes tu
      deuda y pagarás menos intereses en total.
    </>
  ),
  END_OF_MONTH_DESCRIPTION: (
    <>
      Con la modalidad de pago Fin de mes, el cliente paga al final del mes, sin
      intereses, todo el crédito utilizado durante el mes. La opción
      seleccionada no afecta a esta compra ni a futuros pagos fraccionados.
      <br />
      Recuerda que desde la app puedes volver a cambiar de opción cuando
      quieras.
    </>
  ),
  SELECT_PAYMENT_MODE: "Elige tu forma de pago",
  SELECT_PAYMENT_MODE_SUBTITLE: "Elige como quieres pagar tus próximas compras",
  CARD_SHIPPING_DESCRIPTION:
    "Cuando termines la solicitud, podrás recoger tu tarjeta en el espacio habilitado en la tienda o bien te la enviaremos para que la puedas utilizar en tus compras.",
  FIXED_INSTALMENT_INFORMATION_DESCRIPTION:
    "Recuerda que a partir de ahora se aplica una nueva fórmula con un factor corrector para calcular tu cuota mínima y que el importe de esta cuota mínima puede cambiar de un mes a otro ya que tiene en cuenta el total de tu importe gastado. El objetivo de esta nueva fórmula es asegurar que con esta cuota mínima el pago de la deuda no se alargue excesivamente y tampoco pagues intereses de forma indefinida.",
  OTHER_AMOUNT: "Otro importe",
  REPAYMENT_AMOUNT_GREATER_THAN_MAX: "El importe máximo es de $v1€",
  MONTHLY_AMOUNT: "Importe mensual:",
  CARD_INSURANCE: "Seguro de protección de pagos",
  CARD_INSURANCE_SUBTITLE:
    "Activa tu seguro de protección de pagos de forma voluntaria",
  SEE_EXAMPLE: "Ver ejemplo",
  WHAT_IS_THE_INSURANCE_COST: "¿Cual es el coste del seguro?",
  CARD_INSURANCE_EXAMPLE_CAPTION_TOP:
    "El coste del seguro será de $v1 por cada 100€ de deuda.",
  CARD_INSURANCE_EXAMPLE_CAPTION_BOTTOM:
    "Ejemplo de compra de 300€ en 3 cuotas de 100€",
  CARD_INSURANCE_EXAMPLE_COL_MONTH: "Mes",
  CARD_INSURANCE_EXAMPLE_COL_DEBT: "Deuda",
  CARD_INSURANCE_EXAMPLE_COL_INSURANCE: "¿Qué pago de seguro?",
  CARD_INSURANCE_EXAMPLE_COL_TOTAL: "¿Qué pago en total?",
  CARD_INSURANCE_EXAMPLE_MONTH_1: "Mes 1",
  CARD_INSURANCE_EXAMPLE_MONTH_2: "Mes 2",
  CARD_INSURANCE_EXAMPLE_MONTH_3: "Mes 3",
  CARD_INSURANCE_DESCRIPTION_START: (
    <>
      Estar protegido con el Seguro de Protección de Pagos te supone una mínima
      cantidad al mes y, a cambio, te beneficias de la máxima tranquilidad.
    </>
  ),
  CARD_INSURANCE_DESCRIPTION_END: (
    <>
      Este seguro es voluntario y su no contratación no afecta a las condiciones
      económicas del producto de financiación.
    </>
  ),
  CARD_INSURANCE_CONDITIONS:
    "Sólo deberás pagar $v1 al mes por cada 100€ de deuda.",
  IMPORTANT_INFORMATION: "¡Información importante!",
  IMPORTANT: "Importante",
  CARD_DOCUMENTATION_VALIDATION_INSTRUCTIONS: (
    <>
      Tras la firma del contrato, será necesario{" "}
      <strong>validar tu documentación</strong>. Dirígete al mostrador de
      financiación de IKEA con el <strong>código QR</strong> que recibirás por
      correo electrónico para que un agente realice la validación.
    </>
  ),
  UNEMPLOYMENT_PROTECTION_INSURANCE: "Protección de desempleo",
  UNEMPLOYMENT_PROTECTION_INSURANCE_DESCRIPTION:
    "Indemnización con 10% del saldo disponible hasta la fecha de despido, y con un máximo de 6 mensualidades consecuentes con un máximo de 400€ al mes.",
  PAYMENT_PROTECTION_INSURANCE: "Garantía de pago",
  [`PAYMENT_PROTECTION_INSURANCE_DESCRIPTION_${INSURANCE_PACK.SENIOR}`]:
    "Cobertura de liquidación del crédito pendiente en caso de fallecimiento del titular.",
  [`PAYMENT_PROTECTION_INSURANCE_DESCRIPTION_${INSURANCE_PACK.PROTECTION_PLUS}`]:
    "Cobertura de liquidación del crédito pendiente en caso de gran invalidez, fallecimiento, cáncer o infarto del titular.",
  APPLY_WITH_INSURANCE: "Solicitar con seguro",
  APPLY_WITHOUT_INSURANCE: "Solicitar sin seguro",
  DO_YOU_WANT_TO_HAVE_INSURANCE: "¿Deseas proteger tus futuras compras?",
  PLEASE_SELECT_IF_YOU_WANT_TO_HAVE_INSURANCE:
    "Por favor, selecciona si quieres contratar seguro",
  LEGAL_TERMS: "Información legal",
  LEGAL_TERMS_SUBTITLE: "Sobre el seguro de protección de pagos",
  LEGAL_TERMS_DESCRIPTION: (
    <>
      <p>
        Al indicar "Quiero proteger mis futuras compras", declaro a los efectos
        de esta Solicitud que a día de hoy, no padezco ninguna enfermedad grave
        por mi conocida, ni me encuentro en situación de incapacidad permanente
        en alguno de sus grados (total, parcial, absoluta o gran invalidez), o
        temporal que pudiera derivar en incapacidad permanente, ni me encuentro
        en situación de desempleo, en caso de que contrate la cobertura de
        desempleo o incapacidad temporal.
      </p>
      <p>
        Información sujeta a las condiciones de la póliza contenida en las
        Condiciones generales de contratación a las que he accedido y que he
        leído. CaixaBank Payments & Consumer, E.F.C., E.P., S.A.U. (CaixaBank
        Payments & Consumer), con CIF A-08980153 y domicilio en Avenida de
        Manoteras nº 20. Edificio París. 28050 Madrid, media en la contratación
        del seguro como operador de banca-seguros vinculado de VidaCaixa S.A. de
        Seguros y Reaseguros y de SegurCaixa Adeslas S.A. de Seguros y
        Reaseguros, inscrito en el Registro administrativo especial de
        mediadores de seguros de la Dirección General de Seguros y Fondos de
        Pensiones, con el número OV0077, según puede comprobarse ante esta, con
        domicilio en Paseo de la Castellana, 259C, edificio Torre de Cristal,
        Madrid (28046), teléfono 91 339 70 00, www.dgsfp.mineco.es, tiene
        concertado un seguro de responsabilidad civil y dispone de una capacidad
        financiera de acuerdo con los requisitos legales. La empresa matriz de
        CaixaBank Payments & Consumer tiene una participación superior al 10%
        del capital social de VidaCaixa y de SegurCaixa.
      </p>
    </>
  ),
  SEE_LEGAL_TERMS: "Ver información legal",
  VALIDATION_LINK: "Validación de datos",
  VALIDATION_LINK_SUBTITLE: "Escanea el código QR para validar tus datos",
  VALIDATION_LINK_QR_CODE_DESCRIPTION:
    "Como último paso, dirígete al mostrador de atención al cliente de IKEA, donde un agente validará toda la información y emitirá tu tarjeta.",
  VALIDATION_LINK_QR_CODE_DESCRIPTION_1: (
    <>
      <p style={{ fontSize: "1.25rem", fontWeight: "700" }}>¡Felicidades!</p>
      <p>
        <strong>
          Has completado con éxito la solicitud de tu tarjeta VISA IKEA.
        </strong>
      </p>
      <p>
        Para facilitarte tu compra de hoy, dirígete a cualquier zona de
        planificación.{" "}
        <strong>
          ¡Dispones <u>de hasta 3 horas para recoger tu tarjeta!</u>
        </strong>
      </p>
      <p>
        Muestra el siguiente <strong>código para agilizar la gestión:</strong>
      </p>
    </>
  ),
  VALIDATION_LINK_QR_CODE_DESCRIPTION_2: (
    <>
      <p>
        <strong>
          Te recomendamos acudir lo antes posible, pero si crees que no podrás
          recogerla en las próximas 3 horas, ¡no te preocupes! Recibirás tu
          tarjeta en tu domicilio en un plazo de 7 a 10 días.
        </strong>
      </p>
      <p>
        Recuerda que podrás activar y disfrutar de todas las funcionalidades de
        tu tarjeta en nuestra app: desde enrolarla a gestionar el
        fraccionamiento de tus compras.
      </p>
    </>
  ),
  PRODUCT: "Producto",
  PAYMENT_MODE: "Modo de pago",
  FIXED_INSTALMENT_AMOUNT: "Importe del pago aplazado",
  SELECT_FIXED_INSTALMENT_AMOUNT: "Selecciona un importe:",
  FIXED_INSTALMENT_AMOUNT_SUBTITLE:
    "Elige la cantidad de dinero que quieres pagar cada mes",
  PRODUCT_DESCRIPTION: "Descripción del producto",
  [PaymentMode.END_OF_MONTH]: "Fin de mes",
  [PaymentMode.FIXED_INSTALLMENT]: "Pago aplazado",
  CREDIT_LIMIT_NOTICE: "Límite de crédito concedido: $v1",

  // ACTIONS MESSAGES
  ACTION_GENERIC_ERROR: "¡Oops! Se ha producido un error.",
  ACTION_GENERIC_INFO: "La acción se ha realizado correctamente",
  ACTION_GENERIC_SUCCESS: "La acción se ha realizado correctamente",
  ACTION_GENERIC_WARNING: "Por favor revisa los datos",
  ACTION_GENERIC_ERROR_TITLE: "La acción no se ha podido realizar",

  ACTION_REQUEST_GET_SIGNATURE_URL_BY_LOAN_ID_REJECTED: (
    <div>
      <p>
        En estos momentos no hemos sido capaces de conectar con el banco para
        seguir con el proceso de firma.
      </p>
      <br></br>
      <span>Por favor: </span>
      <p>
        <ul>
          <li>
            Vuelve a intentar comunicar con el banco clicando en el botón abajo.
          </li>
          <li>Si el error persiste, vuelve a intentarlo más tarde.</li>
        </ul>
      </p>
    </div>
  ),
  SHOW_MORE: "Mostrar más",
  SHOW_LESS: "Ocultar",

  //Exceptions
  EXCEPTION_BorrowerOnboardingDetailsReferenceIsNotNullException:
    "Esta solicitud ya tiene un cotitular asignado",
  [ACTION_EXCEPTIONS.INVALID_DOCUMENT_NUMBER_EXCEPTION]: (
    <>
      <p>Parece que el numero del documento de indentidad no es válido.</p>
      <p>Por favor, vuelve a realizar la video-identificación.</p>
    </>
  ),
  [ACTION_EXCEPTIONS.INVALID_ELECTRONIC_ID_INFORMATION_EXCEPTION]: (
    <>
      <p>Parece que alguna información no ha sido registrada correctamente.</p>
      <p>Por favor, vuelve a realizar la video-identificación.</p>
    </>
  ),
  [ACTION_EXCEPTIONS.INVALID_ISO3166_EXCEPTION]: (
    <>
      <p>Parece que tu nacionalidad no ha sido correctamente registrada.</p>
      <p>Por favor, vuelve a realizar la video-identificación.</p>
    </>
  ),
  [ACTION_EXCEPTIONS.INVALID_DATE_EXCEPTION]: (
    <>
      <p>Parece que la fecha es inválida.</p>
      <p>Por favor, vuelve a realizar la video-identificación.</p>
    </>
  ),
  RETRY_VIDEO_ID_BUTTON: "Reintentar video-identificación",
  // SignatureEmbeddedSAML
  SIGN: "Revisar y firmar contrato",
  FOLLOW_INSTRUCTIONS_TO_SIGN: "Sigue las instrucciones para firmar contrato",
  PROCEED_TO_DIGITAL_SIGNATURE: "Revisión y firma digital",
  CONTRACT_SIGNATURE: "Firma de contrato",
  CONNECTING: "Conectando...",
  RETRIEVING_DATA: "Recuperando datos...",
  DIGITAL_SIGNATURE_INFO: "Al continuar iniciarás el proceso de firma digital",
  REVIEW_SIGNATURE_INFO: "No te preocupes, podrás revisar todo antes de firmar",
  SIGNATURE_URL_REQUEST_ERROR:
    "En estos momentos no hemos sido capaces de conectar con el banco para seguir con el proceso de firma.",
  TRY_AGAIN_PRESS_BUTTON:
    "Vuelve a intentar comunicar con el banco dandonle al botón abajo.",
  TRY_AGAIN_LATER: "Si el error persiste, vuelve a intentarlo más tarde.",
  BEFORE_PROCEEDING_YOU_NEED_TO_ANSWER:
    "Antes de firmar el contrato, se requiere que contestes a las siguientes opciones.",
  FINALIZE: "Continuar",
  CLICK_FINALIZE_AFTER_SIGNATURE: 'Al acabar la firma, haz clic en "Continuar"',

  ACTION_LOAN_NOT_SIGNED: (
    <>
      Aún no hemos podido validar que la firma del contrato se haya completado.
      <br />
      <p style={{ fontWeight: "normal" }}>
        Es necesario confirmar que el proceso de firma se haya finalizado para
        continuar con la solicitud. Una vez completado el proceso, vuelve a
        hacer click en "Continuar".
      </p>
    </>
  ),

  // Misc
  POWERED_BY: "Powered by",

  // Payment
  BACK: "Volver",
  PAYMENT: "Pago",
  YOUR_INSTALMENT: "Tu cuota",
  INSTALMENT_DETAIL: "Detalle de la cuota actual",
  REVIEW_PAYMENT_PLAN: "Revisar plan de pago",
  YOUR_PAYMENT_PLAN: "Tu plan de pago",
  PAYMENT_PLAN_STATUS: "Estado de las cuotas pagadas",
  PAY_QUOTA_NUMBER: "Pagar cuota $v1",
  TOTAL_PAID_AMOUNT: "Total pagado",
  TOTAL_REMAINING_AMOUNT: "Total pendiente",
  INSTALMENTS_PAID: "Cuotas pagadas",
  OF: "de",
  PAY_AMOUNT: "Pagar $v1",
  QUOTA_NUMBER: "Número de cuota",
  QUOTA_AMOUNT: "Importe cuota",
  DUE_DATE: "Fecha vencimiento",
  PAYMENT_STATUS: "Estado del pago",
  [`PAYMENT_PLAN_LINE_STATUS_${PaymentPlanLineStatus.PENDING}`]: "Pendiente",
  [`PAYMENT_PLAN_LINE_STATUS_${PaymentPlanLineStatus.PROCESSING}`]:
    "Pago iniciado",
  [`PAYMENT_PLAN_LINE_STATUS_${PaymentPlanLineStatus.PAID}`]: "Pagada",
  [`PAYMENT_PLAN_LINE_STATUS_${PaymentPlanLineStatus.CANCELLED}`]: "Cancelada",
  PAYMENT_PLAN_LINE_PAID_TITLE: "Cuota pagada",
  PAYMENT_PLAN_LINE_PAID_TEXT:
    "Esta cuota se encuentra pagada correctamente. En este momento, no queda ninguna acción pendiente por realizar. Puedes cerrar esta pestaña.",
  PAYMENT_PLAN_LINE_PENDING_TITLE: "Cuota pendiente",
  PAYMENT_PLAN_LINE_PENDING_TEXT:
    "Ha surgido un problema al realizar el pago de esta cuota. Por favor, vuelve a intentar realizar el pago haciendo click en el botón.",
  PAYMENT_PLAN_LINE_PROCESSING_TITLE: "Pago iniciado",
  PAYMENT_PLAN_LINE_PROCESSING_TEXT:
    "El pago de la cuota se ha iniciado y se encuentra en estado pendiente. En caso de haber recibido instrucciones para realizar el pago, por favor complétalas y vuelve a acceder a este enlace. Si no es así, puede ser que el sistema esté tardando un poco más de lo habitual. De todos modos, una vez el pago haya sido procesado correctamente, la cuota aparecerá pagada. Si hay cualquier incidencia, podrás volver a intentar el pago.",
  PAYMENT_PLAN_LINE_CANCELLED_TITLE: "Cuota cancelada",
  PAYMENT_PLAN_LINE_CANCELLED_TEXT:
    "Esta cuota se encuentra cancelada. En este momento, no queda ninguna acción pendiente por realizar. Puedes cerrar esta pestaña.",
  PAYMENT_RESULT_SUCCESS_TITLE: "¡Todo listo!",
  PAYMENT_RESULT_SUCCESS_TEXT:
    "El pago de la cuota se ha realizado correctamente. Puedes cerrar esta pestaña.",
  PAYMENT_RESULT_PROCESSING_TITLE: "Pago iniciado",
  PAYMENT_RESULT_PROCESSING_TEXT:
    "El pago de la cuota se ha iniciado y se encuentra en estado pendiente. En caso de haber recibido instrucciones para realizar el pago, por favor complétalas y vuelve a acceder a este enlace. Si no es así, puede ser que el sistema esté tardando un poco más de lo habitual. De todos modos, una vez el pago haya sido procesado correctamente, la cuota aparecerá pagada. Si hay cualquier incidencia, podrás volver a intentar el pago.",
  PAYMENT_RESULT_PAID_TITLE: "Pago realizado correctamente",
  PAYMENT_RESULT_ERROR_TITLE: "¡Ooops!",
  PAYMENT_RESULT_ERROR_TEXT:
    "Parece que se ha producido un error al intentar procesar el pago de la cuota y no se ha podido realizar el cobro. Por favor, haz click en el botón para reintentar el pago de la cuota.",
  FLYWIRE_PAYMENT_INSTALMENT_DETAIL:
    "Haz click para realizar el pago la cuota actual y recuerda que cada mes recibirás un correo electrónico para poder realizar el pago de la cuota correspondiente a través del método de pago que más te convenga.",
  QUOTA_WITH_NUMBER: "Cuota $v1",
  QUOTA_AND_SETUP_FEE_WITH_NUMBER: "Cuota $v1 + Comisión de apertura",

  //ARIA LABELS
  DNI_ARIA_LABEL: "Documento de identidad español",
  NIE_UE_ARIA_LABEL: "Documento de identidad europea",
  NIE_NON_UE_ARIA_LABEL: "Documento de identidad fuera de la Unión Europea",
  PASSPORT_ARIA_LABEL: "Pasaporte",

  //LENDER SELECTION
  INSTALMENT_AMOUNT: "Cuota",
  SELECT: "Seleccionar",
  SELECT_LENDER: "Entidades financieras",
  SELECT_LENDER_SUBTITLE:
    "Selecciona una de las siguientes opciones para continuar con el proceso",
  SELECT_ONE_OF_THE_FOLLOWING_OPTIONS: "Condiciones disponibles:",
  SELECT_LENDER_DESCRIPTION:
    " Al seleccionar la entidad financiera deseada, se ajustarán las condiciones de la solicitud a las mostradas. Podrás ver el detalle ampliado en el contrato de financiación que deberás firmar.",
  ANSWERED_YES: "Aceptada",
  ANSWERED_NO: "Denegada",
  IN_STUDY: "En estudio",
  FINANCING_PROVIDED_BY: "Financiación ofrecida por",
  TO_PAY: "A pagar",
  CONTINUE_WITH: "Continuar con",
  [LenderName.CAIXABANK]: "CaixaBank",
  [LenderName.CETELEM]: "Cetelem",
  [LenderName.BS]: "Banco Sabadell",
  [LenderName.BBVA]: "BBVA",
  [LenderName.SOYOU]: "Sofinco",
  [LenderName.ABANCA]: "Abanca",
  [LenderName.SANTANDER]: "Santander",
  [LenderName.SANTANDER_CONSUMER]: "Santander Consumer",

  LOAN_CONDITIONS: "Condiciones",
  SECTION_LOAN_CONDITIONS: "Condiciones",
  END_SECTION_LOAN_CONDITIONS: "Condiciones seleccionadas",
  AVAILABLE_LENDERS: "Entidades disponibles en el plazo seleccionado",
  LENDERS: "Entidades disponibles",
  QUOTA_SELECTION: "Selección de cuota",
  SECTION_LOAN_CONDITIONS_END: "Condiciones seleccionadas",

  //Call Me back panel
  CAN_WE_HELP_YOU: "¿Hablamos?",
  FULL_NAME: "Nombre completo",
  PREFERRED_TIME_SLOT: "Franja horaria preferida",
  DO_YOU_NEED_HELP_WITH_YOUR_APPLICATION:
    "¿Necesitas ayuda con tu financiación?",
  YOU_CAN_CALL_US_OR_WE_CALL_YOU_BACK:
    "Puedes llamarnos al 931 227 103 o dejanos tus datos y te llamamos nosotros.",
  REQUEST_CALL: "Solicitar llamada",
  PHONE_NUMBER: "Teléfono de contacto",
  ASAP: "Lo antes posible",
  MORNING: "Mañana (9h-12h)",
  NOON: "Mediodía (12h-15h)",
  AFTERNOON: "Tarde (15h-18h)",
  EVENING: "Noche (18h-21h)",
  THANK_YOU_FOR_COMMUNICATING_WITH_US: "¡Gracias por comunicarte con nosotros!",
  WE_WILL_CALL_YOU_BACK_AT_THE_SPECIFIED_TIME:
    "Te llamaremos en la franja indicada.",
  CALL_ME_BACK_DATA_TREATMENT: (
    <>
      <h3>Información sobre tratamiento de datos:</h3>
      <p style={{ marginBlock: "0.3rem" }}>
        <strong>Finalidad:</strong> Gestionar tu solicitud de asistencia en la
        financiación y contactarte telefónicamente según nos has solicitado.
      </p>
      <p style={{ marginBlock: "0.3rem" }}>
        <strong>Base jurídica:</strong> Aplicación de medidas precontractuales
        (art. 6.1.b RGPD).
      </p>
      <p style={{ marginBlock: "0.3rem" }}>
        <strong>Conservación:</strong> Conservaremos tus datos mientras
        gestionamos tu solicitud y hasta 15 días después de la última
        interacción, bloqueándose posteriormente para atender posibles
        reclamaciones conforme a la normativa.
      </p>
      <p style={{ marginBlock: "0.3rem" }}>
        <strong>Derechos:</strong> Puedes ejercer tus derechos de acceso,
        rectificación, supresión, oposición, limitación y portabilidad a través
        de{" "}
        <a href="mailto:ejerciciodederechos@caixabankpc.com" target="_blank">
          ejerciciodederechos@caixabankpc.com
        </a>{" "}
        indicando como referencia “Facilitea – Vehículo de Ocasión” y aportando
        copia de tu documento de identidad.
      </p>
      <p style={{ marginBlock: "0.3rem" }}>
        Puedes consultar la información completa sobre el tratamiento de tus
        datos en nuestra política de privacidad{" "}
        <a
          href="https://www.caixabankpc.com/es/politica-de-privacidad"
          target="_blank"
        >
          https://www.caixabankpc.com/es/politica-de-privacidad
        </a>
      </p>
    </>
  ),
};

export default es;
